var vt = [509, 0, 227, 0, 150, 4, 294, 9, 1368, 2, 2, 1, 6, 3, 41, 2, 5, 0, 166, 1, 574, 3, 9, 9, 7, 9, 32, 4, 318, 1, 78, 5, 71, 10, 50, 3, 123, 2, 54, 14, 32, 10, 3, 1, 11, 3, 46, 10, 8, 0, 46, 9, 7, 2, 37, 13, 2, 9, 6, 1, 45, 0, 13, 2, 49, 13, 9, 3, 2, 11, 83, 11, 7, 0, 3, 0, 158, 11, 6, 9, 7, 3, 56, 1, 2, 6, 3, 1, 3, 2, 10, 0, 11, 1, 3, 6, 4, 4, 68, 8, 2, 0, 3, 0, 2, 3, 2, 4, 2, 0, 15, 1, 83, 17, 10, 9, 5, 0, 82, 19, 13, 9, 214, 6, 3, 8, 28, 1, 83, 16, 16, 9, 82, 12, 9, 9, 7, 19, 58, 14, 5, 9, 243, 14, 166, 9, 71, 5, 2, 1, 3, 3, 2, 0, 2, 1, 13, 9, 120, 6, 3, 6, 4, 0, 29, 9, 41, 6, 2, 3, 9, 0, 10, 10, 47, 15, 199, 7, 137, 9, 54, 7, 2, 7, 17, 9, 57, 21, 2, 13, 123, 5, 4, 0, 2, 1, 2, 6, 2, 0, 9, 9, 49, 4, 2, 1, 2, 4, 9, 9, 55, 9, 266, 3, 10, 1, 2, 0, 49, 6, 4, 4, 14, 10, 5350, 0, 7, 14, 11465, 27, 2343, 9, 87, 9, 39, 4, 60, 6, 26, 9, 535, 9, 470, 0, 2, 54, 8, 3, 82, 0, 12, 1, 19628, 1, 4178, 9, 519, 45, 3, 22, 543, 4, 4, 5, 9, 7, 3, 6, 31, 3, 149, 2, 1418, 49, 513, 54, 5, 49, 9, 0, 15, 0, 23, 4, 2, 14, 1361, 6, 2, 16, 3, 6, 2, 1, 2, 4, 101, 0, 161, 6, 10, 9, 357, 0, 62, 13, 499, 13, 245, 1, 2, 9, 233, 0, 3, 0, 8, 1, 6, 0, 475, 6, 110, 6, 6, 9, 4759, 9, 787719, 239], Le = [0, 11, 2, 25, 2, 18, 2, 1, 2, 14, 3, 13, 35, 122, 70, 52, 268, 28, 4, 48, 48, 31, 14, 29, 6, 37, 11, 29, 3, 35, 5, 7, 2, 4, 43, 157, 19, 35, 5, 35, 5, 39, 9, 51, 13, 10, 2, 14, 2, 6, 2, 1, 2, 10, 2, 14, 2, 6, 2, 1, 4, 51, 13, 310, 10, 21, 11, 7, 25, 5, 2, 41, 2, 8, 70, 5, 3, 0, 2, 43, 2, 1, 4, 0, 3, 22, 11, 22, 10, 30, 66, 18, 2, 1, 11, 21, 11, 25, 7, 25, 39, 55, 7, 1, 65, 0, 16, 3, 2, 2, 2, 28, 43, 28, 4, 28, 36, 7, 2, 27, 28, 53, 11, 21, 11, 18, 14, 17, 111, 72, 56, 50, 14, 50, 14, 35, 39, 27, 10, 22, 251, 41, 7, 1, 17, 5, 57, 28, 11, 0, 9, 21, 43, 17, 47, 20, 28, 22, 13, 52, 58, 1, 3, 0, 14, 44, 33, 24, 27, 35, 30, 0, 3, 0, 9, 34, 4, 0, 13, 47, 15, 3, 22, 0, 2, 0, 36, 17, 2, 24, 20, 1, 64, 6, 2, 0, 2, 3, 2, 14, 2, 9, 8, 46, 39, 7, 3, 1, 3, 21, 2, 6, 2, 1, 2, 4, 4, 0, 19, 0, 13, 4, 31, 9, 2, 0, 3, 0, 2, 37, 2, 0, 26, 0, 2, 0, 45, 52, 19, 3, 21, 2, 31, 47, 21, 1, 2, 0, 185, 46, 42, 3, 37, 47, 21, 0, 60, 42, 14, 0, 72, 26, 38, 6, 186, 43, 117, 63, 32, 7, 3, 0, 3, 7, 2, 1, 2, 23, 16, 0, 2, 0, 95, 7, 3, 38, 17, 0, 2, 0, 29, 0, 11, 39, 8, 0, 22, 0, 12, 45, 20, 0, 19, 72, 200, 32, 32, 8, 2, 36, 18, 0, 50, 29, 113, 6, 2, 1, 2, 37, 22, 0, 26, 5, 2, 1, 2, 31, 15, 0, 24, 43, 261, 18, 16, 0, 2, 12, 2, 33, 125, 0, 80, 921, 103, 110, 18, 195, 2637, 96, 16, 1071, 18, 5, 26, 3994, 6, 582, 6842, 29, 1763, 568, 8, 30, 18, 78, 18, 29, 19, 47, 17, 3, 32, 20, 6, 18, 433, 44, 212, 63, 33, 24, 3, 24, 45, 74, 6, 0, 67, 12, 65, 1, 2, 0, 15, 4, 10, 7381, 42, 31, 98, 114, 8702, 3, 2, 6, 2, 1, 2, 290, 16, 0, 30, 2, 3, 0, 15, 3, 9, 395, 2309, 106, 6, 12, 4, 8, 8, 9, 5991, 84, 2, 70, 2, 1, 3, 0, 3, 1, 3, 3, 2, 11, 2, 0, 2, 6, 2, 64, 2, 3, 3, 7, 2, 6, 2, 27, 2, 3, 2, 4, 2, 0, 4, 6, 2, 339, 3, 24, 2, 24, 2, 30, 2, 24, 2, 30, 2, 24, 2, 30, 2, 24, 2, 30, 2, 24, 2, 7, 1845, 30, 7, 5, 262, 61, 147, 44, 11, 6, 17, 0, 322, 29, 19, 43, 485, 27, 229, 29, 3, 0, 208, 30, 2, 2, 2, 1, 2, 6, 3, 4, 10, 1, 225, 6, 2, 3, 2, 1, 2, 14, 2, 196, 60, 67, 8, 0, 1205, 3, 2, 26, 2, 1, 2, 0, 3, 0, 2, 9, 2, 3, 2, 0, 2, 0, 7, 0, 5, 0, 2, 0, 2, 0, 2, 2, 2, 1, 2, 0, 3, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 1, 2, 0, 3, 3, 2, 6, 2, 3, 2, 3, 2, 0, 2, 9, 2, 16, 6, 2, 2, 4, 2, 16, 4421, 42719, 33, 4381, 3, 5773, 3, 7472, 16, 621, 2467, 541, 1507, 4938, 6, 8489], gt = "‌‍·̀-ͯ·҃-֑҇-ׇֽֿׁׂׅׄؐ-ًؚ-٩ٰۖ-ۜ۟-۪ۤۧۨ-ۭ۰-۹ܑܰ-݊ަ-ް߀-߉߫-߽߳ࠖ-࠙ࠛ-ࠣࠥ-ࠧࠩ-࡙࠭-࡛ࢗ-࢟࣊-ࣣ࣡-ःऺ-़ा-ॏ॑-ॗॢॣ०-९ঁ-ঃ়া-ৄেৈো-্ৗৢৣ০-৯৾ਁ-ਃ਼ਾ-ੂੇੈੋ-੍ੑ੦-ੱੵઁ-ઃ઼ા-ૅે-ૉો-્ૢૣ૦-૯ૺ-૿ଁ-ଃ଼ା-ୄେୈୋ-୍୕-ୗୢୣ୦-୯ஂா-ூெ-ைொ-்ௗ௦-௯ఀ-ఄ఼ా-ౄె-ైొ-్ౕౖౢౣ౦-౯ಁ-ಃ಼ಾ-ೄೆ-ೈೊ-್ೕೖೢೣ೦-೯ೳഀ-ഃ഻഼ാ-ൄെ-ൈൊ-്ൗൢൣ൦-൯ඁ-ඃ්ා-ුූෘ-ෟ෦-෯ෲෳัิ-ฺ็-๎๐-๙ັິ-ຼ່-໎໐-໙༘༙༠-༩༹༵༷༾༿ཱ-྄྆྇ྍ-ྗྙ-ྼ࿆ါ-ှ၀-၉ၖ-ၙၞ-ၠၢ-ၤၧ-ၭၱ-ၴႂ-ႍႏ-ႝ፝-፟፩-፱ᜒ-᜕ᜲ-᜴ᝒᝓᝲᝳ឴-៓៝០-៩᠋-᠍᠏-᠙ᢩᤠ-ᤫᤰ-᤻᥆-᥏᧐-᧚ᨗ-ᨛᩕ-ᩞ᩠-᩿᩼-᪉᪐-᪙᪰-᪽ᪿ-᫝᫠-᫫ᬀ-ᬄ᬴-᭄᭐-᭙᭫-᭳ᮀ-ᮂᮡ-ᮭ᮰-᮹᯦-᯳ᰤ-᰷᱀-᱉᱐-᱙᳐-᳔᳒-᳨᳭᳴᳷-᳹᷀-᷿‌‍‿⁀⁔⃐-⃥⃜⃡-⃰⳯-⵿⳱ⷠ-〪ⷿ-゙゚〯・꘠-꘩꙯ꙴ-꙽ꚞꚟ꛰꛱ꠂ꠆ꠋꠣ-ꠧ꠬ꢀꢁꢴ-ꣅ꣐-꣙꣠-꣱ꣿ-꤉ꤦ-꤭ꥇ-꥓ꦀ-ꦃ꦳-꧀꧐-꧙ꧥ꧰-꧹ꨩ-ꨶꩃꩌꩍ꩐-꩙ꩻ-ꩽꪰꪲ-ꪴꪷꪸꪾ꪿꫁ꫫ-ꫯꫵ꫶ꯣ-ꯪ꯬꯭꯰-꯹ﬞ︀-️︠-︯︳︴﹍-﹏０-９＿･", Re = "ªµºÀ-ÖØ-öø-ˁˆ-ˑˠ-ˤˬˮͰ-ʹͶͷͺ-ͽͿΆΈ-ΊΌΎ-ΡΣ-ϵϷ-ҁҊ-ԯԱ-Ֆՙՠ-ֈא-תׯ-ײؠ-يٮٯٱ-ۓەۥۦۮۯۺ-ۼۿܐܒ-ܯݍ-ޥޱߊ-ߪߴߵߺࠀ-ࠕࠚࠤࠨࡀ-ࡘࡠ-ࡪࡰ-ࢇࢉ-࢏ࢠ-ࣉऄ-हऽॐक़-ॡॱ-ঀঅ-ঌএঐও-নপ-রলশ-হঽৎড়ঢ়য়-ৡৰৱৼਅ-ਊਏਐਓ-ਨਪ-ਰਲਲ਼ਵਸ਼ਸਹਖ਼-ੜਫ਼ੲ-ੴઅ-ઍએ-ઑઓ-નપ-રલળવ-હઽૐૠૡૹଅ-ଌଏଐଓ-ନପ-ରଲଳଵ-ହଽଡ଼ଢ଼ୟ-ୡୱஃஅ-ஊஎ-ஐஒ-கஙசஜஞடணதந-பம-ஹௐఅ-ఌఎ-ఐఒ-నప-హఽౘ-ౚ౜ౝౠౡಀಅ-ಌಎ-ಐಒ-ನಪ-ಳವ-ಹಽ೜-ೞೠೡೱೲഄ-ഌഎ-ഐഒ-ഺഽൎൔ-ൖൟ-ൡൺ-ൿඅ-ඖක-නඳ-රලව-ෆก-ะาำเ-ๆກຂຄຆ-ຊຌ-ຣລວ-ະາຳຽເ-ໄໆໜ-ໟༀཀ-ཇཉ-ཬྈ-ྌက-ဪဿၐ-ၕၚ-ၝၡၥၦၮ-ၰၵ-ႁႎႠ-ჅჇჍა-ჺჼ-ቈቊ-ቍቐ-ቖቘቚ-ቝበ-ኈኊ-ኍነ-ኰኲ-ኵኸ-ኾዀዂ-ዅወ-ዖዘ-ጐጒ-ጕጘ-ፚᎀ-ᎏᎠ-Ᏽᏸ-ᏽᐁ-ᙬᙯ-ᙿᚁ-ᚚᚠ-ᛪᛮ-ᛸᜀ-ᜑᜟ-ᜱᝀ-ᝑᝠ-ᝬᝮ-ᝰក-ឳៗៜᠠ-ᡸᢀ-ᢨᢪᢰ-ᣵᤀ-ᤞᥐ-ᥭᥰ-ᥴᦀ-ᦫᦰ-ᧉᨀ-ᨖᨠ-ᩔᪧᬅ-ᬳᭅ-ᭌᮃ-ᮠᮮᮯᮺ-ᯥᰀ-ᰣᱍ-ᱏᱚ-ᱽᲀ-ᲊᲐ-ᲺᲽ-Ჿᳩ-ᳬᳮ-ᳳᳵᳶᳺᴀ-ᶿḀ-ἕἘ-Ἕἠ-ὅὈ-Ὅὐ-ὗὙὛὝὟ-ώᾀ-ᾴᾶ-ᾼιῂ-ῄῆ-ῌῐ-ΐῖ-Ίῠ-Ῥῲ-ῴῶ-ῼⁱⁿₐ-ₜℂℇℊ-ℓℕ℘-ℝℤΩℨK-ℹℼ-ℿⅅ-ⅉⅎⅠ-ↈⰀ-ⳤⳫ-ⳮⳲⳳⴀ-ⴥⴧⴭⴰ-ⵧⵯⶀ-ⶖⶠ-ⶦⶨ-ⶮⶰ-ⶶⶸ-ⶾⷀ-ⷆⷈ-ⷎⷐ-ⷖⷘ-ⷞ々-〇〡-〩〱-〵〸-〼ぁ-ゖ゛-ゟァ-ヺー-ヿㄅ-ㄯㄱ-ㆎㆠ-ㆿㇰ-ㇿ㐀-䶿一-ꒌꓐ-ꓽꔀ-ꘌꘐ-ꘟꘪꘫꙀ-ꙮꙿ-ꚝꚠ-ꛯꜗ-ꜟꜢ-ꞈꞋ-Ƛ꟱-ꠁꠃ-ꠅꠇ-ꠊꠌ-ꠢꡀ-ꡳꢂ-ꢳꣲ-ꣷꣻꣽꣾꤊ-ꤥꤰ-ꥆꥠ-ꥼꦄ-ꦲꧏꧠ-ꧤꧦ-ꧯꧺ-ꧾꨀ-ꨨꩀ-ꩂꩄ-ꩋꩠ-ꩶꩺꩾ-ꪯꪱꪵꪶꪹ-ꪽꫀꫂꫛ-ꫝꫠ-ꫪꫲ-ꫴꬁ-ꬆꬉ-ꬎꬑ-ꬖꬠ-ꬦꬨ-ꬮꬰ-ꭚꭜ-ꭩꭰ-ꯢ가-힣ힰ-ퟆퟋ-ퟻ豈-舘並-龎ﬀ-ﬆﬓ-ﬗיִײַ-ﬨשׁ-זּטּ-לּמּנּסּףּפּצּ-ﮱﯓ-ﴽﵐ-ﶏﶒ-ﷇﷰ-ﷻﹰ-ﹴﹶ-ﻼＡ-Ｚａ-ｚｦ-ﾾￂ-ￇￊ-ￏￒ-ￗￚ-ￜ", fe = {
  3: "abstract boolean byte char class double enum export extends final float goto implements import int interface long native package private protected public short static super synchronized throws transient volatile",
  5: "class enum extends super const export import",
  6: "enum",
  strict: "implements interface let package private protected public static yield",
  strictBind: "eval arguments"
}, de = "break case catch continue debugger default do else finally for function if return switch throw try var while with null true false instanceof typeof void delete new in this", bt = {
  5: de,
  "5module": de + " export import",
  6: de + " const class extends export import super"
}, Oe = /^in(stanceof)?$/, yt = new RegExp("[" + Re + "]"), _t = new RegExp("[" + Re + gt + "]");
function me(e, t) {
  for (var i = 65536, s = 0; s < t.length; s += 2) {
    if (i += t[s], i > e)
      return !1;
    if (i += t[s + 1], i >= e)
      return !0;
  }
  return !1;
}
function L(e, t) {
  return e < 65 ? e === 36 : e < 91 ? !0 : e < 97 ? e === 95 : e < 123 ? !0 : e <= 65535 ? e >= 170 && yt.test(String.fromCharCode(e)) : t === !1 ? !1 : me(e, Le);
}
function U(e, t) {
  return e < 48 ? e === 36 : e < 58 ? !0 : e < 65 ? !1 : e < 91 ? !0 : e < 97 ? e === 95 : e < 123 ? !0 : e <= 65535 ? e >= 170 && _t.test(String.fromCharCode(e)) : t === !1 ? !1 : me(e, Le) || me(e, vt);
}
var g = function(t, i) {
  i === void 0 && (i = {}), this.label = t, this.keyword = i.keyword, this.beforeExpr = !!i.beforeExpr, this.startsExpr = !!i.startsExpr, this.isLoop = !!i.isLoop, this.isAssign = !!i.isAssign, this.prefix = !!i.prefix, this.postfix = !!i.postfix, this.binop = i.binop || null, this.updateContext = null;
};
function A(e, t) {
  return new g(e, { beforeExpr: !0, binop: t });
}
var I = { beforeExpr: !0 }, k = { startsExpr: !0 }, ye = {};
function v(e, t) {
  return t === void 0 && (t = {}), t.keyword = e, ye[e] = new g(e, t);
}
var r = {
  num: new g("num", k),
  regexp: new g("regexp", k),
  string: new g("string", k),
  name: new g("name", k),
  privateId: new g("privateId", k),
  eof: new g("eof"),
  // Punctuation token types.
  bracketL: new g("[", { beforeExpr: !0, startsExpr: !0 }),
  bracketR: new g("]"),
  braceL: new g("{", { beforeExpr: !0, startsExpr: !0 }),
  braceR: new g("}"),
  parenL: new g("(", { beforeExpr: !0, startsExpr: !0 }),
  parenR: new g(")"),
  comma: new g(",", I),
  semi: new g(";", I),
  colon: new g(":", I),
  dot: new g("."),
  question: new g("?", I),
  questionDot: new g("?."),
  arrow: new g("=>", I),
  template: new g("template"),
  invalidTemplate: new g("invalidTemplate"),
  ellipsis: new g("...", I),
  backQuote: new g("`", k),
  dollarBraceL: new g("${", { beforeExpr: !0, startsExpr: !0 }),
  // Operators. These carry several kinds of properties to help the
  // parser use them properly (the presence of these properties is
  // what categorizes them as operators).
  //
  // `binop`, when present, specifies that this operator is a binary
  // operator, and will refer to its precedence.
  //
  // `prefix` and `postfix` mark the operator as a prefix or postfix
  // unary operator.
  //
  // `isAssign` marks all of `=`, `+=`, `-=` etcetera, which act as
  // binary operators with a very low precedence, that should result
  // in AssignmentExpression nodes.
  eq: new g("=", { beforeExpr: !0, isAssign: !0 }),
  assign: new g("_=", { beforeExpr: !0, isAssign: !0 }),
  incDec: new g("++/--", { prefix: !0, postfix: !0, startsExpr: !0 }),
  prefix: new g("!/~", { beforeExpr: !0, prefix: !0, startsExpr: !0 }),
  logicalOR: A("||", 1),
  logicalAND: A("&&", 2),
  bitwiseOR: A("|", 3),
  bitwiseXOR: A("^", 4),
  bitwiseAND: A("&", 5),
  equality: A("==/!=/===/!==", 6),
  relational: A("</>/<=/>=", 7),
  bitShift: A("<</>>/>>>", 8),
  plusMin: new g("+/-", { beforeExpr: !0, binop: 9, prefix: !0, startsExpr: !0 }),
  modulo: A("%", 10),
  star: A("*", 10),
  slash: A("/", 10),
  starstar: new g("**", { beforeExpr: !0 }),
  coalesce: A("??", 1),
  // Keyword token types.
  _break: v("break"),
  _case: v("case", I),
  _catch: v("catch"),
  _continue: v("continue"),
  _debugger: v("debugger"),
  _default: v("default", I),
  _do: v("do", { isLoop: !0, beforeExpr: !0 }),
  _else: v("else", I),
  _finally: v("finally"),
  _for: v("for", { isLoop: !0 }),
  _function: v("function", k),
  _if: v("if"),
  _return: v("return", I),
  _switch: v("switch"),
  _throw: v("throw", I),
  _try: v("try"),
  _var: v("var"),
  _const: v("const"),
  _while: v("while", { isLoop: !0 }),
  _with: v("with"),
  _new: v("new", { beforeExpr: !0, startsExpr: !0 }),
  _this: v("this", k),
  _super: v("super", k),
  _class: v("class", k),
  _extends: v("extends", I),
  _export: v("export"),
  _import: v("import", k),
  _null: v("null", k),
  _true: v("true", k),
  _false: v("false", k),
  _in: v("in", { beforeExpr: !0, binop: 7 }),
  _instanceof: v("instanceof", { beforeExpr: !0, binop: 7 }),
  _typeof: v("typeof", { beforeExpr: !0, prefix: !0, startsExpr: !0 }),
  _void: v("void", { beforeExpr: !0, prefix: !0, startsExpr: !0 }),
  _delete: v("delete", { beforeExpr: !0, prefix: !0, startsExpr: !0 })
}, w = /\r\n?|\n|\u2028|\u2029/, St = new RegExp(w.source, "g");
function K(e) {
  return e === 10 || e === 13 || e === 8232 || e === 8233;
}
function Be(e, t, i) {
  i === void 0 && (i = e.length);
  for (var s = t; s < i; s++) {
    var a = e.charCodeAt(s);
    if (K(a))
      return s < i - 1 && a === 13 && e.charCodeAt(s + 1) === 10 ? s + 2 : s + 1;
  }
  return -1;
}
var De = /[\u1680\u2000-\u200a\u202f\u205f\u3000\ufeff]/, S = /(?:\s|\/\/.*|\/\*[^]*?\*\/)*/g, Fe = Object.prototype, Ct = Fe.hasOwnProperty, kt = Fe.toString, Q = Object.hasOwn || (function(e, t) {
  return Ct.call(e, t);
}), Ae = Array.isArray || (function(e) {
  return kt.call(e) === "[object Array]";
}), Ie = /* @__PURE__ */ Object.create(null);
function M(e) {
  return Ie[e] || (Ie[e] = new RegExp("^(?:" + e.replace(/ /g, "|") + ")$"));
}
function O(e) {
  return e <= 65535 ? String.fromCharCode(e) : (e -= 65536, String.fromCharCode((e >> 10) + 55296, (e & 1023) + 56320));
}
var wt = /(?:[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])/, Z = function(t, i) {
  this.line = t, this.column = i;
};
Z.prototype.offset = function(t) {
  return new Z(this.line, this.column + t);
};
var ne = function(t, i, s) {
  this.start = i, this.end = s, t.sourceFile !== null && (this.source = t.sourceFile);
};
function Me(e, t) {
  for (var i = 1, s = 0; ; ) {
    var a = Be(e, s, t);
    if (a < 0)
      return new Z(i, t - s);
    ++i, s = a;
  }
}
var ve = {
  // `ecmaVersion` indicates the ECMAScript version to parse. Must be
  // either 3, 5, 6 (or 2015), 7 (2016), 8 (2017), 9 (2018), 10
  // (2019), 11 (2020), 12 (2021), 13 (2022), 14 (2023), or `"latest"`
  // (the latest version the library supports). This influences
  // support for strict mode, the set of reserved words, and support
  // for new syntax features.
  ecmaVersion: null,
  // `sourceType` indicates the mode the code should be parsed in.
  // Can be either `"script"`, `"module"` or `"commonjs"`. This influences global
  // strict mode and parsing of `import` and `export` declarations.
  sourceType: "script",
  // When set to true, enable strict parsing mode even if `sourceType`
  // is `"script"`.
  strict: !1,
  // `onInsertedSemicolon` can be a callback that will be called when
  // a semicolon is automatically inserted. It will be passed the
  // position of the inserted semicolon as an offset, and if
  // `locations` is enabled, it is given the location as a `{line,
  // column}` object as second argument.
  onInsertedSemicolon: null,
  // `onTrailingComma` is similar to `onInsertedSemicolon`, but for
  // trailing commas.
  onTrailingComma: null,
  // By default, reserved words are only enforced if ecmaVersion >= 5.
  // Set `allowReserved` to a boolean value to explicitly turn this on
  // an off. When this option has the value "never", reserved words
  // and keywords can also not be used as property names.
  allowReserved: null,
  // When enabled, a return at the top level is not considered an
  // error.
  allowReturnOutsideFunction: !1,
  // When enabled, import/export statements are not constrained to
  // appearing at the top of the program, and an import.meta expression
  // in a script isn't considered an error.
  allowImportExportEverywhere: !1,
  // By default, await identifiers are allowed to appear at the top-level scope only if ecmaVersion >= 2022.
  // When enabled, await identifiers are allowed to appear at the top-level scope,
  // but they are still not allowed in non-async functions.
  allowAwaitOutsideFunction: null,
  // When enabled, super identifiers are not constrained to
  // appearing in methods and do not raise an error when they appear elsewhere.
  allowSuperOutsideMethod: null,
  // When enabled, hashbang directive in the beginning of file is
  // allowed and treated as a line comment. Enabled by default when
  // `ecmaVersion` >= 2023.
  allowHashBang: !1,
  // By default, the parser will verify that private properties are
  // only used in places where they are valid and have been declared.
  // Set this to false to turn such checks off.
  checkPrivateFields: !0,
  // When `locations` is on, `loc` properties holding objects with
  // `start` and `end` properties in `{line, column}` form (with
  // line being 1-based and column 0-based) will be attached to the
  // nodes.
  locations: !1,
  // Pass an optional `{line, column}` object to use for the start of
  // the parse. This is mostly useful when using `parseExpressionAt`
  // with `locations: true`, to prevent the parser from having to
  // determine the line position at the start position.
  startLocation: null,
  // A function can be passed as `onToken` option, which will
  // cause Acorn to call that function with object in the same
  // format as tokens returned from `tokenizer().getToken()`. Note
  // that you are not allowed to call the parser from the
  // callback—that will corrupt its internal state.
  onToken: null,
  // A function can be passed as `onComment` option, which will
  // cause Acorn to call that function with `(block, text, start,
  // end)` parameters whenever a comment is skipped. `block` is a
  // boolean indicating whether this is a block (`/* */`) comment,
  // `text` is the content of the comment, and `start` and `end` are
  // character offsets that denote the start and end of the comment.
  // When the `locations` option is on, two more parameters are
  // passed, the full `{line, column}` locations of the start and
  // end of the comments. Note that you are not allowed to call the
  // parser from the callback—that will corrupt its internal state.
  // When this option has an array as value, objects representing the
  // comments are pushed to it.
  onComment: null,
  // Nodes have their start and end characters offsets recorded in
  // `start` and `end` properties (directly on the node, rather than
  // the `loc` object, which holds line/column data. To also add a
  // [semi-standardized][range] `range` property holding a `[start,
  // end]` array with the same numbers, set the `ranges` option to
  // `true`.
  //
  // [range]: https://bugzilla.mozilla.org/show_bug.cgi?id=745678
  ranges: !1,
  // It is possible to parse multiple files into a single AST by
  // passing the tree produced by parsing the first file as
  // `program` option in subsequent parses. This will add the
  // toplevel forms of the parsed file to the `Program` (top) node
  // of an existing parse tree.
  program: null,
  // When `locations` is on, you can pass this to record the source
  // file in every node's `loc` object.
  sourceFile: null,
  // This value, if given, is stored in every node, whether
  // `locations` is on or off.
  directSourceFile: null,
  // When enabled, parenthesized expressions are represented by
  // (non-standard) ParenthesizedExpression nodes
  preserveParens: !1
}, Pe = !1;
function Et(e) {
  var t = {};
  for (var i in ve)
    t[i] = e && Q(e, i) ? e[i] : ve[i];
  if (t.ecmaVersion === "latest" ? t.ecmaVersion = 1e8 : t.ecmaVersion == null ? (!Pe && typeof console == "object" && console.warn && (Pe = !0, console.warn(`Since Acorn 8.0.0, options.ecmaVersion is required.
Defaulting to 2020, but this will stop working in the future.`)), t.ecmaVersion = 11) : t.ecmaVersion >= 2015 && (t.ecmaVersion -= 2009), t.allowReserved == null && (t.allowReserved = t.ecmaVersion < 5), (!e || e.allowHashBang == null) && (t.allowHashBang = t.ecmaVersion >= 14), Ae(t.onToken)) {
    var s = t.onToken;
    t.onToken = function(a) {
      return s.push(a);
    };
  }
  if (Ae(t.onComment) && (t.onComment = At(t, t.onComment)), t.sourceType === "commonjs" && t.allowAwaitOutsideFunction)
    throw new Error("Cannot use allowAwaitOutsideFunction with sourceType: commonjs");
  return t;
}
function At(e, t) {
  return function(i, s, a, n, o, u) {
    var h = {
      type: i ? "Block" : "Line",
      value: s,
      start: a,
      end: n
    };
    e.locations && (h.loc = new ne(this, o, u)), e.ranges && (h.range = [a, n]), t.push(h);
  };
}
var q = 1, G = 2, _e = 4, Ue = 8, Se = 16, je = 32, oe = 64, qe = 128, W = 256, J = 512, Ge = 1024, ue = q | G | W;
function Ce(e, t) {
  return G | (e ? _e : 0) | (t ? Ue : 0);
}
var ie = 0, ke = 1, D = 2, We = 3, He = 4, ze = 5, _ = function(t, i, s) {
  this.options = t = Et(t), this.sourceFile = t.sourceFile, this.keywords = M(bt[t.ecmaVersion >= 6 ? 6 : t.sourceType === "module" ? "5module" : 5]);
  var a = "";
  t.allowReserved !== !0 && (a = fe[t.ecmaVersion >= 6 ? 6 : t.ecmaVersion === 5 ? 5 : 3], t.sourceType === "module" && (a += " await")), this.reservedWords = M(a);
  var n = (a ? a + " " : "") + fe.strict;
  this.reservedWordsStrict = M(n), this.reservedWordsStrictBind = M(n + " " + fe.strictBind), this.input = String(i), this.containsEsc = !1, this.pos = s || 0, this.curLine = 1, t.startLocation ? (this.lineStart = this.pos - t.startLocation.column, this.curLine = t.startLocation.line) : s ? (this.lineStart = this.input.lastIndexOf(`
`, s - 1) + 1, this.options.locations && (this.curLine = this.input.slice(0, this.lineStart).split(w).length)) : this.lineStart = 0, this.type = r.eof, this.value = null, this.start = this.end = this.pos, this.startLoc = this.endLoc = this.curPosition(), this.lastTokEndLoc = this.lastTokStartLoc = null, this.lastTokStart = this.lastTokEnd = this.pos, this.context = this.initialContext(), this.exprAllowed = !0, this.inModule = t.sourceType === "module", this.strict = this.inModule || t.strict === !0 || this.strictDirective(this.pos), this.potentialArrowAt = -1, this.potentialArrowInForAwait = !1, this.yieldPos = this.awaitPos = this.awaitIdentPos = 0, this.labels = [], this.undefinedExports = /* @__PURE__ */ Object.create(null), this.pos === 0 && t.allowHashBang && this.input.slice(0, 2) === "#!" && this.skipLineComment(2), this.scopeStack = [], this.enterScope(
    this.options.sourceType === "commonjs" ? G : q
  ), this.regexpState = null, this.privateNameStack = [];
}, N = { inFunction: { configurable: !0 }, inGenerator: { configurable: !0 }, inAsync: { configurable: !0 }, canAwait: { configurable: !0 }, allowReturn: { configurable: !0 }, allowSuper: { configurable: !0 }, allowDirectSuper: { configurable: !0 }, treatFunctionsAsVar: { configurable: !0 }, allowNewDotTarget: { configurable: !0 }, allowUsing: { configurable: !0 }, inClassStaticBlock: { configurable: !0 } };
_.prototype.parse = function() {
  var t = this, i = this.options.program || this.startNode();
  return this.nextToken(), this.catchStackOverflow(function() {
    return t.parseTopLevel(i);
  });
};
N.inFunction.get = function() {
  return (this.currentVarScope().flags & G) > 0;
};
N.inGenerator.get = function() {
  return (this.currentVarScope().flags & Ue) > 0;
};
N.inAsync.get = function() {
  return (this.currentVarScope().flags & _e) > 0;
};
N.canAwait.get = function() {
  for (var e = this.scopeStack.length - 1; e >= 0; e--) {
    var t = this.scopeStack[e], i = t.flags;
    if (i & (W | J))
      return !1;
    if (i & G)
      return (i & _e) > 0;
  }
  return this.inModule && this.options.ecmaVersion >= 13 || this.options.allowAwaitOutsideFunction;
};
N.allowReturn.get = function() {
  return !!(this.inFunction || this.options.allowReturnOutsideFunction && this.currentVarScope().flags & q);
};
N.allowSuper.get = function() {
  var e = this.currentThisScope(), t = e.flags;
  return (t & oe) > 0 || this.options.allowSuperOutsideMethod;
};
N.allowDirectSuper.get = function() {
  return (this.currentThisScope().flags & qe) > 0;
};
N.treatFunctionsAsVar.get = function() {
  return this.treatFunctionsAsVarInScope(this.currentScope());
};
N.allowNewDotTarget.get = function() {
  for (var e = this.scopeStack.length - 1; e >= 0; e--) {
    var t = this.scopeStack[e], i = t.flags;
    if (i & (W | J) || i & G && !(i & Se))
      return !0;
  }
  return !1;
};
N.allowUsing.get = function() {
  var e = this.currentScope(), t = e.flags;
  return !(t & Ge || !this.inModule && t & q);
};
N.inClassStaticBlock.get = function() {
  return (this.currentVarScope().flags & W) > 0;
};
_.extend = function() {
  for (var t = [], i = arguments.length; i--; ) t[i] = arguments[i];
  for (var s = this, a = 0; a < t.length; a++)
    s = t[a](s);
  return s;
};
_.parse = function(t, i) {
  return new this(i, t).parse();
};
_.parseExpressionAt = function(t, i, s) {
  var a = new this(s, t, i);
  return a.nextToken(), a.parseExpression();
};
_.tokenizer = function(t, i) {
  return new this(i, t);
};
Object.defineProperties(_.prototype, N);
var C = _.prototype, It = /^(?:'((?:\\[^]|[^'\\])*?)'|"((?:\\[^]|[^"\\])*?)")/;
C.strictDirective = function(e) {
  if (this.options.ecmaVersion < 5)
    return !1;
  for (; ; ) {
    S.lastIndex = e, e += S.exec(this.input)[0].length;
    var t = It.exec(this.input.slice(e));
    if (!t)
      return !1;
    if ((t[1] || t[2]) === "use strict") {
      S.lastIndex = e + t[0].length;
      var i = S.exec(this.input), s = i.index + i[0].length, a = this.input.charAt(s);
      return a === ";" || a === "}" || w.test(i[0]) && !(/[(`.[+\-/*%<>=,?^&]/.test(a) || a === "!" && this.input.charAt(s + 1) === "=");
    }
    e += t[0].length, S.lastIndex = e, e += S.exec(this.input)[0].length, this.input[e] === ";" && e++;
  }
};
C.eat = function(e) {
  return this.type === e ? (this.next(), !0) : !1;
};
C.isContextual = function(e) {
  return this.type === r.name && this.value === e && !this.containsEsc;
};
C.eatContextual = function(e) {
  return this.isContextual(e) ? (this.next(), !0) : !1;
};
C.catchStackOverflow = function(e) {
  try {
    return e();
  } catch (t) {
    if (t instanceof Error && (/\bstack\b.*\b(exceeded|overflow)\b/i.test(t.message) || /\btoo much recursion\b/i.test(t.message)))
      this.raise(this.start, "Not enough stack space to parse input");
    else
      throw t;
  }
};
C.expectContextual = function(e) {
  this.eatContextual(e) || this.unexpected();
};
C.canInsertSemicolon = function() {
  return this.type === r.eof || this.type === r.braceR || w.test(this.input.slice(this.lastTokEnd, this.start));
};
C.insertSemicolon = function() {
  if (this.canInsertSemicolon())
    return this.options.onInsertedSemicolon && this.options.onInsertedSemicolon(this.lastTokEnd, this.lastTokEndLoc), !0;
};
C.semicolon = function() {
  !this.eat(r.semi) && !this.insertSemicolon() && this.unexpected();
};
C.afterTrailingComma = function(e, t) {
  if (this.type === e)
    return this.options.onTrailingComma && this.options.onTrailingComma(this.lastTokStart, this.lastTokStartLoc), t || this.next(), !0;
};
C.expect = function(e) {
  this.eat(e) || this.unexpected();
};
C.unexpected = function(e) {
  this.raise(e ?? this.start, "Unexpected token");
};
var he = function() {
  this.shorthandAssign = this.trailingComma = this.parenthesizedAssign = this.parenthesizedBind = this.doubleProto = -1;
};
C.checkPatternErrors = function(e, t) {
  if (e) {
    e.trailingComma > -1 && this.raiseRecoverable(e.trailingComma, "Comma is not permitted after the rest element");
    var i = t ? e.parenthesizedAssign : e.parenthesizedBind;
    i > -1 && this.raiseRecoverable(i, t ? "Assigning to rvalue" : "Parenthesized pattern");
  }
};
C.checkExpressionErrors = function(e, t) {
  if (!e)
    return !1;
  var i = e.shorthandAssign, s = e.doubleProto;
  if (!t)
    return i >= 0 || s >= 0;
  i >= 0 && this.raise(i, "Shorthand property assignments are valid only in destructuring patterns"), s >= 0 && this.raiseRecoverable(s, "Redefinition of __proto__ property");
};
C.checkYieldAwaitInDefaultParams = function() {
  this.yieldPos && (!this.awaitPos || this.yieldPos < this.awaitPos) && this.raise(this.yieldPos, "Yield expression cannot be a default value"), this.awaitPos && this.raise(this.awaitPos, "Await expression cannot be a default value");
};
C.isSimpleAssignTarget = function(e) {
  return e.type === "ParenthesizedExpression" ? this.isSimpleAssignTarget(e.expression) : e.type === "Identifier" || e.type === "MemberExpression";
};
var l = _.prototype;
l.parseTopLevel = function(e) {
  var t = /* @__PURE__ */ Object.create(null);
  for (e.body || (e.body = []); this.type !== r.eof; ) {
    var i = this.parseStatement(null, !0, t);
    e.body.push(i);
  }
  if (this.inModule)
    for (var s = 0, a = Object.keys(this.undefinedExports); s < a.length; s += 1) {
      var n = a[s];
      this.raiseRecoverable(this.undefinedExports[n].start, "Export '" + n + "' is not defined");
    }
  return this.adaptDirectivePrologue(e.body), this.next(), e.sourceType = this.options.sourceType === "commonjs" ? "script" : this.options.sourceType, this.finishNode(e, "Program");
};
var we = { kind: "loop" }, Pt = { kind: "switch" };
l.isLet = function(e) {
  if (this.options.ecmaVersion < 6 || !this.isContextual("let"))
    return !1;
  S.lastIndex = this.pos;
  var t = S.exec(this.input), i = this.pos + t[0].length, s = this.fullCharCodeAt(i);
  if (s === 91 || s === 92)
    return !0;
  if (e)
    return !1;
  if (s === 123)
    return !0;
  if (L(s)) {
    var a = i;
    do
      i += s <= 65535 ? 1 : 2;
    while (U(s = this.fullCharCodeAt(i)));
    if (s === 92)
      return !0;
    var n = this.input.slice(a, i);
    if (!Oe.test(n))
      return !0;
  }
  return !1;
};
l.isAsyncFunction = function() {
  if (this.options.ecmaVersion < 8 || !this.isContextual("async"))
    return !1;
  S.lastIndex = this.pos;
  var e = S.exec(this.input), t = this.pos + e[0].length, i;
  return !w.test(this.input.slice(this.pos, t)) && this.input.slice(t, t + 8) === "function" && (t + 8 === this.input.length || !(U(i = this.fullCharCodeAt(t + 8)) || i === 92));
};
l.isUsingKeyword = function(e, t) {
  if (this.options.ecmaVersion < 17 || !this.isContextual(e ? "await" : "using"))
    return !1;
  S.lastIndex = this.pos;
  var i = S.exec(this.input), s = this.pos + i[0].length;
  if (w.test(this.input.slice(this.pos, s)))
    return !1;
  if (e) {
    var a = s + 5, n;
    if (this.input.slice(s, a) !== "using" || a === this.input.length || U(n = this.fullCharCodeAt(a)) || n === 92)
      return !1;
    S.lastIndex = a;
    var o = S.exec(this.input);
    if (s = a + o[0].length, o && w.test(this.input.slice(a, s)))
      return !1;
  }
  var u = this.fullCharCodeAt(s);
  if (!L(u) && u !== 92)
    return !1;
  var h = s;
  do
    s += u <= 65535 ? 1 : 2;
  while (U(u = this.fullCharCodeAt(s)));
  if (u === 92)
    return !0;
  var p = this.input.slice(h, s);
  if (Oe.test(p))
    return !1;
  if (t && !e && p === "of") {
    S.lastIndex = s;
    var d = S.exec(this.input);
    if (s = s + d[0].length, this.input.charCodeAt(s) !== 61 || // Check for ==, === and => operators
    (u = this.input.charCodeAt(s + 1)) === 61 || u === 62)
      return !1;
  }
  return !0;
};
l.isAwaitUsing = function(e) {
  return this.isUsingKeyword(!0, e);
};
l.isUsing = function(e) {
  return this.isUsingKeyword(!1, e);
};
l.parseStatement = function(e, t, i) {
  var s = this.type, a = this.startNode(), n;
  switch (this.isLet(e) && (s = r._var, n = "let"), s) {
    case r._break:
    case r._continue:
      return this.parseBreakContinueStatement(a, s.keyword);
    case r._debugger:
      return this.parseDebuggerStatement(a);
    case r._do:
      return this.parseDoStatement(a);
    case r._for:
      return this.parseForStatement(a);
    case r._function:
      return e && (this.strict || e !== "if" && e !== "label") && this.options.ecmaVersion >= 6 && this.unexpected(), this.parseFunctionStatement(a, !1, !e);
    case r._class:
      return e && this.unexpected(), this.parseClass(a, !0);
    case r._if:
      return this.parseIfStatement(a);
    case r._return:
      return this.parseReturnStatement(a);
    case r._switch:
      return this.parseSwitchStatement(a);
    case r._throw:
      return this.parseThrowStatement(a);
    case r._try:
      return this.parseTryStatement(a);
    case r._const:
    case r._var:
      return n = n || this.value, e && n !== "var" && this.unexpected(), this.parseVarStatement(a, n);
    case r._while:
      return this.parseWhileStatement(a);
    case r._with:
      return this.parseWithStatement(a);
    case r.braceL:
      return this.parseBlock(!0, a);
    case r.semi:
      return this.parseEmptyStatement(a);
    case r._export:
    case r._import:
      if (this.options.ecmaVersion > 10 && s === r._import) {
        S.lastIndex = this.pos;
        var o = S.exec(this.input), u = this.pos + o[0].length, h = this.input.charCodeAt(u);
        if (h === 40 || h === 46)
          return this.parseExpressionStatement(a, this.parseExpression());
      }
      return this.options.allowImportExportEverywhere || (t || this.raise(this.start, "'import' and 'export' may only appear at the top level"), this.inModule || this.raise(this.start, "'import' and 'export' may appear only with 'sourceType: module'")), s === r._import ? this.parseImport(a) : this.parseExport(a, i);
    // If the statement does not start with a statement keyword or a
    // brace, it's an ExpressionStatement or LabeledStatement. We
    // simply start parsing an expression, and afterwards, if the
    // next token is a colon and the expression was a simple
    // Identifier node, we switch to interpreting it as a label.
    default:
      if (this.isAsyncFunction())
        return e && this.unexpected(), this.next(), this.parseFunctionStatement(a, !0, !e);
      var p = this.isAwaitUsing(!1) ? "await using" : this.isUsing(!1) ? "using" : null;
      if (p)
        return this.allowUsing || this.raise(this.start, "Using declaration cannot appear in the top level when source type is `script` or in the bare case statement"), e && this.raise(this.start, "Using declaration is not allowed in single-statement positions"), p === "await using" && (this.canAwait || this.raise(this.start, "Await using cannot appear outside of async function"), this.next()), this.next(), this.parseVar(a, !1, p), this.semicolon(), this.finishNode(a, "VariableDeclaration");
      var d = this.value, b = this.parseExpression();
      return s === r.name && b.type === "Identifier" && this.eat(r.colon) ? this.parseLabeledStatement(a, d, b, e) : this.parseExpressionStatement(a, b);
  }
};
l.parseBreakContinueStatement = function(e, t) {
  var i = t === "break";
  this.next(), this.eat(r.semi) || this.insertSemicolon() ? e.label = null : this.type !== r.name ? this.unexpected() : (e.label = this.parseIdent(), this.semicolon());
  for (var s = 0; s < this.labels.length; ++s) {
    var a = this.labels[s];
    if ((e.label == null || a.name === e.label.name) && (a.kind != null && (i || a.kind === "loop") || e.label && i))
      break;
  }
  return s === this.labels.length && this.raise(e.start, "Unsyntactic " + t), this.finishNode(e, i ? "BreakStatement" : "ContinueStatement");
};
l.parseDebuggerStatement = function(e) {
  return this.next(), this.semicolon(), this.finishNode(e, "DebuggerStatement");
};
l.parseDoStatement = function(e) {
  return this.next(), this.labels.push(we), e.body = this.parseStatement("do"), this.labels.pop(), this.expect(r._while), e.test = this.parseParenExpression(), this.options.ecmaVersion >= 6 ? this.eat(r.semi) : this.semicolon(), this.finishNode(e, "DoWhileStatement");
};
l.parseForStatement = function(e) {
  this.next();
  var t = this.options.ecmaVersion >= 9 && this.canAwait && this.eatContextual("await") ? this.lastTokStart : -1;
  if (this.labels.push(we), this.enterScope(0), this.expect(r.parenL), this.type === r.semi)
    return t > -1 && this.unexpected(t), this.parseFor(e, null);
  var i = this.isLet();
  if (this.type === r._var || this.type === r._const || i) {
    var s = this.startNode(), a = i ? "let" : this.value;
    return this.next(), this.parseVar(s, !0, a), this.finishNode(s, "VariableDeclaration"), this.parseForAfterInit(e, s, t);
  }
  var n = this.isContextual("let"), o = !1, u = this.isUsing(!0) ? "using" : this.isAwaitUsing(!0) ? "await using" : null;
  if (u) {
    var h = this.startNode();
    return this.next(), u === "await using" && (this.canAwait || this.raise(this.start, "Await using cannot appear outside of async function"), this.next()), this.parseVar(h, !0, u), this.finishNode(h, "VariableDeclaration"), this.parseForAfterInit(e, h, t);
  }
  var p = this.containsEsc, d = new he(), b = this.start, x = t > -1 ? this.parseExprSubscripts(d, "await") : this.parseExpression(!0, d);
  return this.type === r._in || (o = this.options.ecmaVersion >= 6 && this.isContextual("of")) ? (t > -1 ? (this.type === r._in && this.unexpected(t), e.await = !0) : o && this.options.ecmaVersion >= 8 && (x.start === b && !p && x.type === "Identifier" && x.name === "async" ? this.unexpected() : this.options.ecmaVersion >= 9 && (e.await = !1)), n && o && this.raise(x.start, "The left-hand side of a for-of loop may not start with 'let'."), this.toAssignable(x, !1, d), this.checkLValPattern(x), this.parseForIn(e, x)) : (this.checkExpressionErrors(d, !0), t > -1 && this.unexpected(t), this.parseFor(e, x));
};
l.parseForAfterInit = function(e, t, i) {
  return (this.type === r._in || this.options.ecmaVersion >= 6 && this.isContextual("of")) && t.declarations.length === 1 ? (this.type === r._in ? ((t.kind === "using" || t.kind === "await using") && !t.declarations[0].init && this.raise(this.start, "Using declaration is not allowed in for-in loops"), this.options.ecmaVersion >= 9 && i > -1 && this.unexpected(i)) : this.options.ecmaVersion >= 9 && (e.await = i > -1), this.parseForIn(e, t)) : (i > -1 && this.unexpected(i), this.parseFor(e, t));
};
l.parseFunctionStatement = function(e, t, i) {
  return this.next(), this.parseFunction(e, X | (i ? 0 : ge), !1, t);
};
l.parseIfStatement = function(e) {
  return this.next(), e.test = this.parseParenExpression(), e.consequent = this.parseStatement("if"), e.alternate = this.eat(r._else) ? this.parseStatement("if") : null, this.finishNode(e, "IfStatement");
};
l.parseReturnStatement = function(e) {
  return this.allowReturn || this.raise(this.start, "'return' outside of function"), this.next(), this.eat(r.semi) || this.insertSemicolon() ? e.argument = null : (e.argument = this.parseExpression(), this.semicolon()), this.finishNode(e, "ReturnStatement");
};
l.parseSwitchStatement = function(e) {
  this.next(), e.discriminant = this.parseParenExpression(), e.cases = [], this.expect(r.braceL), this.labels.push(Pt), this.enterScope(Ge);
  for (var t, i = !1; this.type !== r.braceR; )
    if (this.type === r._case || this.type === r._default) {
      var s = this.type === r._case;
      t && this.finishNode(t, "SwitchCase"), e.cases.push(t = this.startNode()), t.consequent = [], this.next(), s ? t.test = this.parseExpression() : (i && this.raiseRecoverable(this.lastTokStart, "Multiple default clauses"), i = !0, t.test = null), this.expect(r.colon);
    } else
      t || this.unexpected(), t.consequent.push(this.parseStatement(null));
  return this.exitScope(), t && this.finishNode(t, "SwitchCase"), this.next(), this.labels.pop(), this.finishNode(e, "SwitchStatement");
};
l.parseThrowStatement = function(e) {
  return this.next(), w.test(this.input.slice(this.lastTokEnd, this.start)) && this.raise(this.lastTokEnd, "Illegal newline after throw"), e.argument = this.parseExpression(), this.semicolon(), this.finishNode(e, "ThrowStatement");
};
var Nt = [];
l.parseCatchClauseParam = function() {
  var e = this.parseBindingAtom(), t = e.type === "Identifier";
  return this.enterScope(t ? je : 0), this.checkLValPattern(e, t ? He : D), this.expect(r.parenR), e;
};
l.parseTryStatement = function(e) {
  if (this.next(), e.block = this.parseBlock(), e.handler = null, this.type === r._catch) {
    var t = this.startNode();
    this.next(), this.eat(r.parenL) ? t.param = this.parseCatchClauseParam() : (this.options.ecmaVersion < 10 && this.unexpected(), t.param = null, this.enterScope(0)), t.body = this.parseBlock(!1), this.exitScope(), e.handler = this.finishNode(t, "CatchClause");
  }
  return e.finalizer = this.eat(r._finally) ? this.parseBlock() : null, !e.handler && !e.finalizer && this.raise(e.start, "Missing catch or finally clause"), this.finishNode(e, "TryStatement");
};
l.parseVarStatement = function(e, t, i) {
  return this.next(), this.parseVar(e, !1, t, i), this.semicolon(), this.finishNode(e, "VariableDeclaration");
};
l.parseWhileStatement = function(e) {
  return this.next(), e.test = this.parseParenExpression(), this.labels.push(we), e.body = this.parseStatement("while"), this.labels.pop(), this.finishNode(e, "WhileStatement");
};
l.parseWithStatement = function(e) {
  return this.strict && this.raise(this.start, "'with' in strict mode"), this.next(), e.object = this.parseParenExpression(), e.body = this.parseStatement("with"), this.finishNode(e, "WithStatement");
};
l.parseEmptyStatement = function(e) {
  return this.next(), this.finishNode(e, "EmptyStatement");
};
l.parseLabeledStatement = function(e, t, i, s) {
  for (var a = 0, n = this.labels; a < n.length; a += 1) {
    var o = n[a];
    o.name === t && this.raise(i.start, "Label '" + t + "' is already declared");
  }
  for (var u = this.type.isLoop ? "loop" : this.type === r._switch ? "switch" : null, h = this.labels.length - 1; h >= 0; h--) {
    var p = this.labels[h];
    if (p.statementStart === e.start)
      p.statementStart = this.start, p.kind = u;
    else
      break;
  }
  return this.labels.push({ name: t, kind: u, statementStart: this.start }), e.body = this.parseStatement(s ? s.indexOf("label") === -1 ? s + "label" : s : "label"), this.labels.pop(), e.label = i, this.finishNode(e, "LabeledStatement");
};
l.parseExpressionStatement = function(e, t) {
  return e.expression = t, this.semicolon(), this.finishNode(e, "ExpressionStatement");
};
l.parseBlock = function(e, t, i) {
  for (e === void 0 && (e = !0), t === void 0 && (t = this.startNode()), t.body = [], this.expect(r.braceL), e && this.enterScope(0); this.type !== r.braceR; ) {
    var s = this.parseStatement(null);
    t.body.push(s);
  }
  return i && (this.strict = !1), this.next(), e && this.exitScope(), this.finishNode(t, "BlockStatement");
};
l.parseFor = function(e, t) {
  return e.init = t, this.expect(r.semi), e.test = this.type === r.semi ? null : this.parseExpression(), this.expect(r.semi), e.update = this.type === r.parenR ? null : this.parseExpression(), this.expect(r.parenR), e.body = this.parseStatement("for"), this.exitScope(), this.labels.pop(), this.finishNode(e, "ForStatement");
};
l.parseForIn = function(e, t) {
  var i = this.type === r._in;
  return this.next(), t.type === "VariableDeclaration" && t.declarations[0].init != null && (!i || this.options.ecmaVersion < 8 || this.strict || t.kind !== "var" || t.declarations[0].id.type !== "Identifier") && this.raise(
    t.start,
    (i ? "for-in" : "for-of") + " loop variable declaration may not have an initializer"
  ), e.left = t, e.right = i ? this.parseExpression() : this.parseMaybeAssign(), this.expect(r.parenR), e.body = this.parseStatement("for"), this.exitScope(), this.labels.pop(), this.finishNode(e, i ? "ForInStatement" : "ForOfStatement");
};
l.parseVar = function(e, t, i, s) {
  for (e.declarations = [], e.kind = i; ; ) {
    var a = this.startNode();
    if (this.parseVarId(a, i), this.eat(r.eq) ? a.init = this.parseMaybeAssign(t) : !s && i === "const" && !(this.type === r._in || this.options.ecmaVersion >= 6 && this.isContextual("of")) ? this.unexpected() : !s && (i === "using" || i === "await using") && this.options.ecmaVersion >= 17 && this.type !== r._in && !this.isContextual("of") ? this.raise(this.lastTokEnd, "Missing initializer in " + i + " declaration") : !s && a.id.type !== "Identifier" && !(t && (this.type === r._in || this.isContextual("of"))) ? this.raise(this.lastTokEnd, "Complex binding patterns require an initialization value") : a.init = null, e.declarations.push(this.finishNode(a, "VariableDeclarator")), !this.eat(r.comma))
      break;
  }
  return e;
};
l.parseVarId = function(e, t) {
  e.id = t === "using" || t === "await using" ? this.parseIdent() : this.parseBindingAtom(), this.checkLValPattern(e.id, t === "var" ? ke : D, !1);
};
var X = 1, ge = 2, Ke = 4;
l.parseFunction = function(e, t, i, s, a) {
  this.initFunction(e), (this.options.ecmaVersion >= 9 || this.options.ecmaVersion >= 6 && !s) && (this.type === r.star && t & ge && this.unexpected(), e.generator = this.eat(r.star)), this.options.ecmaVersion >= 8 && (e.async = !!s), t & X && (e.id = t & Ke && this.type !== r.name ? null : this.parseIdent(), e.id && !(t & ge) && this.checkLValSimple(e.id, this.strict || e.generator || e.async ? this.treatFunctionsAsVar ? ke : D : We));
  var n = this.yieldPos, o = this.awaitPos, u = this.awaitIdentPos;
  return this.yieldPos = 0, this.awaitPos = 0, this.awaitIdentPos = 0, this.enterScope(Ce(e.async, e.generator)), t & X || (e.id = this.type === r.name ? this.parseIdent() : null), this.parseFunctionParams(e), this.parseFunctionBody(e, i, !1, a), this.yieldPos = n, this.awaitPos = o, this.awaitIdentPos = u, this.finishNode(e, t & X ? "FunctionDeclaration" : "FunctionExpression");
};
l.parseFunctionParams = function(e) {
  this.expect(r.parenL), e.params = this.parseBindingList(r.parenR, !1, this.options.ecmaVersion >= 8), this.checkYieldAwaitInDefaultParams();
};
l.parseClass = function(e, t) {
  this.next();
  var i = this.strict;
  this.strict = !0, this.parseClassId(e, t), this.parseClassSuper(e);
  var s = this.enterClassBody(), a = this.startNode(), n = !1;
  for (a.body = [], this.expect(r.braceL); this.type !== r.braceR; ) {
    var o = this.parseClassElement(e.superClass !== null);
    o && (a.body.push(o), o.type === "MethodDefinition" && o.kind === "constructor" ? (n && this.raiseRecoverable(o.start, "Duplicate constructor in the same class"), n = !0) : o.key && o.key.type === "PrivateIdentifier" && Vt(s, o) && this.raiseRecoverable(o.key.start, "Identifier '#" + o.key.name + "' has already been declared"));
  }
  return this.strict = i, this.next(), e.body = this.finishNode(a, "ClassBody"), this.exitClassBody(), this.finishNode(e, t ? "ClassDeclaration" : "ClassExpression");
};
l.parseClassElement = function(e) {
  if (this.eat(r.semi))
    return null;
  var t = this.options.ecmaVersion, i = this.startNode(), s = "", a = !1, n = !1, o = "method", u = !1;
  if (this.eatContextual("static")) {
    if (t >= 13 && this.eat(r.braceL))
      return this.parseClassStaticBlock(i), i;
    this.isClassElementNameStart() || this.type === r.star ? u = !0 : s = "static";
  }
  if (i.static = u, !s && t >= 8 && this.eatContextual("async") && ((this.isClassElementNameStart() || this.type === r.star) && !this.canInsertSemicolon() ? n = !0 : s = "async"), !s && (t >= 9 || !n) && this.eat(r.star) && (a = !0), !s && !n && !a) {
    var h = this.value;
    (this.eatContextual("get") || this.eatContextual("set")) && (this.isClassElementNameStart() ? o = h : s = h);
  }
  if (s ? (i.computed = !1, i.key = this.startNodeAt(this.lastTokStart, this.lastTokStartLoc), i.key.name = s, this.finishNode(i.key, "Identifier")) : this.parseClassElementName(i), t < 13 || this.type === r.parenL || o !== "method" || a || n) {
    var p = !i.static && se(i, "constructor"), d = p && e;
    p && o !== "method" && this.raise(i.key.start, "Constructor can't have get/set modifier"), i.kind = p ? "constructor" : o, this.parseClassMethod(i, a, n, d);
  } else
    this.parseClassField(i);
  return i;
};
l.isClassElementNameStart = function() {
  return this.type === r.name || this.type === r.privateId || this.type === r.num || this.type === r.string || this.type === r.bracketL || this.type.keyword;
};
l.parseClassElementName = function(e) {
  this.type === r.privateId ? (this.value === "constructor" && this.raise(this.start, "Classes can't have an element named '#constructor'"), e.computed = !1, e.key = this.parsePrivateIdent()) : this.parsePropertyName(e);
};
l.parseClassMethod = function(e, t, i, s) {
  var a = e.key;
  e.kind === "constructor" ? (t && this.raise(a.start, "Constructor can't be a generator"), i && this.raise(a.start, "Constructor can't be an async method")) : e.static && se(e, "prototype") && this.raise(a.start, "Classes may not have a static property named prototype");
  var n = e.value = this.parseMethod(t, i, s);
  return e.kind === "get" && n.params.length !== 0 && this.raiseRecoverable(n.start, "getter should have no params"), e.kind === "set" && n.params.length !== 1 && this.raiseRecoverable(n.start, "setter should have exactly one param"), e.kind === "set" && n.params[0].type === "RestElement" && this.raiseRecoverable(n.params[0].start, "Setter cannot use rest params"), this.finishNode(e, "MethodDefinition");
};
l.parseClassField = function(e) {
  return se(e, "constructor") ? this.raise(e.key.start, "Classes can't have a field named 'constructor'") : e.static && se(e, "prototype") && this.raise(e.key.start, "Classes can't have a static field named 'prototype'"), this.eat(r.eq) ? (this.enterScope(J | oe), e.value = this.parseMaybeAssign(), this.exitScope()) : e.value = null, this.semicolon(), this.finishNode(e, "PropertyDefinition");
};
l.parseClassStaticBlock = function(e) {
  e.body = [];
  var t = this.labels;
  for (this.labels = [], this.enterScope(W | oe); this.type !== r.braceR; ) {
    var i = this.parseStatement(null);
    e.body.push(i);
  }
  return this.next(), this.exitScope(), this.labels = t, this.finishNode(e, "StaticBlock");
};
l.parseClassId = function(e, t) {
  this.type === r.name ? (e.id = this.parseIdent(), t && this.checkLValSimple(e.id, D, !1)) : (t === !0 && this.unexpected(), e.id = null);
};
l.parseClassSuper = function(e) {
  e.superClass = this.eat(r._extends) ? this.parseExprSubscripts(null, !1) : null;
};
l.enterClassBody = function() {
  var e = { declared: /* @__PURE__ */ Object.create(null), used: [] };
  return this.privateNameStack.push(e), e.declared;
};
l.exitClassBody = function() {
  var e = this.privateNameStack.pop(), t = e.declared, i = e.used;
  if (this.options.checkPrivateFields)
    for (var s = this.privateNameStack.length, a = s === 0 ? null : this.privateNameStack[s - 1], n = 0; n < i.length; ++n) {
      var o = i[n];
      Q(t, o.name) || (a ? a.used.push(o) : this.raiseRecoverable(o.start, "Private field '#" + o.name + "' must be declared in an enclosing class"));
    }
};
function Vt(e, t) {
  var i = t.key.name, s = e[i], a = "true";
  return t.type === "MethodDefinition" && (t.kind === "get" || t.kind === "set") && (a = (t.static ? "s" : "i") + t.kind), s === "iget" && a === "iset" || s === "iset" && a === "iget" || s === "sget" && a === "sset" || s === "sset" && a === "sget" ? (e[i] = "true", !1) : s ? !0 : (e[i] = a, !1);
}
function se(e, t) {
  var i = e.computed, s = e.key;
  return !i && (s.type === "Identifier" && s.name === t || s.type === "Literal" && s.value === t);
}
l.parseExportAllDeclaration = function(e, t) {
  return this.options.ecmaVersion >= 11 && (this.eatContextual("as") ? (e.exported = this.parseModuleExportName(), this.checkExport(t, e.exported, this.lastTokStart)) : e.exported = null), this.expectContextual("from"), this.type !== r.string && this.unexpected(), e.source = this.parseExprAtom(), this.options.ecmaVersion >= 16 && (e.attributes = this.parseWithClause()), this.semicolon(), this.finishNode(e, "ExportAllDeclaration");
};
l.parseExport = function(e, t) {
  if (this.next(), this.eat(r.star))
    return this.parseExportAllDeclaration(e, t);
  if (this.eat(r._default))
    return this.checkExport(t, "default", this.lastTokStart), e.declaration = this.parseExportDefaultDeclaration(), this.finishNode(e, "ExportDefaultDeclaration");
  if (this.shouldParseExportStatement())
    e.declaration = this.parseExportDeclaration(e), e.declaration.type === "VariableDeclaration" ? this.checkVariableExport(t, e.declaration.declarations) : this.checkExport(t, e.declaration.id, e.declaration.id.start), e.specifiers = [], e.source = null, this.options.ecmaVersion >= 16 && (e.attributes = []);
  else {
    if (e.declaration = null, e.specifiers = this.parseExportSpecifiers(t), this.eatContextual("from"))
      this.type !== r.string && this.unexpected(), e.source = this.parseExprAtom(), this.options.ecmaVersion >= 16 && (e.attributes = this.parseWithClause());
    else {
      for (var i = 0, s = e.specifiers; i < s.length; i += 1) {
        var a = s[i];
        this.checkUnreserved(a.local), this.checkLocalExport(a.local), a.local.type === "Literal" && this.raise(a.local.start, "A string literal cannot be used as an exported binding without `from`.");
      }
      e.source = null, this.options.ecmaVersion >= 16 && (e.attributes = []);
    }
    this.semicolon();
  }
  return this.finishNode(e, "ExportNamedDeclaration");
};
l.parseExportDeclaration = function(e) {
  return this.parseStatement(null);
};
l.parseExportDefaultDeclaration = function() {
  var e;
  if (this.type === r._function || (e = this.isAsyncFunction())) {
    var t = this.startNode();
    return this.next(), e && this.next(), this.parseFunction(t, X | Ke, !1, e);
  } else if (this.type === r._class) {
    var i = this.startNode();
    return this.parseClass(i, "nullableID");
  } else {
    var s = this.parseMaybeAssign();
    return this.semicolon(), s;
  }
};
l.checkExport = function(e, t, i) {
  e && (typeof t != "string" && (t = t.type === "Identifier" ? t.name : t.value), Q(e, t) && this.raiseRecoverable(i, "Duplicate export '" + t + "'"), e[t] = !0);
};
l.checkPatternExport = function(e, t) {
  var i = t.type;
  if (i === "Identifier")
    this.checkExport(e, t, t.start);
  else if (i === "ObjectPattern")
    for (var s = 0, a = t.properties; s < a.length; s += 1) {
      var n = a[s];
      this.checkPatternExport(e, n);
    }
  else if (i === "ArrayPattern")
    for (var o = 0, u = t.elements; o < u.length; o += 1) {
      var h = u[o];
      h && this.checkPatternExport(e, h);
    }
  else i === "Property" ? this.checkPatternExport(e, t.value) : i === "AssignmentPattern" ? this.checkPatternExport(e, t.left) : i === "RestElement" && this.checkPatternExport(e, t.argument);
};
l.checkVariableExport = function(e, t) {
  if (e)
    for (var i = 0, s = t; i < s.length; i += 1) {
      var a = s[i];
      this.checkPatternExport(e, a.id);
    }
};
l.shouldParseExportStatement = function() {
  return this.type.keyword === "var" || this.type.keyword === "const" || this.type.keyword === "class" || this.type.keyword === "function" || this.isLet() || this.isAsyncFunction();
};
l.parseExportSpecifier = function(e) {
  var t = this.startNode();
  return t.local = this.parseModuleExportName(), t.exported = this.eatContextual("as") ? this.parseModuleExportName() : t.local, this.checkExport(
    e,
    t.exported,
    t.exported.start
  ), this.finishNode(t, "ExportSpecifier");
};
l.parseExportSpecifiers = function(e) {
  var t = [], i = !0;
  for (this.expect(r.braceL); !this.eat(r.braceR); ) {
    if (i)
      i = !1;
    else if (this.expect(r.comma), this.afterTrailingComma(r.braceR))
      break;
    t.push(this.parseExportSpecifier(e));
  }
  return t;
};
l.parseImport = function(e) {
  return this.next(), this.type === r.string ? (e.specifiers = Nt, e.source = this.parseExprAtom()) : (e.specifiers = this.parseImportSpecifiers(), this.expectContextual("from"), e.source = this.type === r.string ? this.parseExprAtom() : this.unexpected()), this.options.ecmaVersion >= 16 && (e.attributes = this.parseWithClause()), this.semicolon(), this.finishNode(e, "ImportDeclaration");
};
l.parseImportSpecifier = function() {
  var e = this.startNode();
  return e.imported = this.parseModuleExportName(), this.eatContextual("as") ? e.local = this.parseIdent() : (this.checkUnreserved(e.imported), e.local = e.imported), this.checkLValSimple(e.local, D), this.finishNode(e, "ImportSpecifier");
};
l.parseImportDefaultSpecifier = function() {
  var e = this.startNode();
  return e.local = this.parseIdent(), this.checkLValSimple(e.local, D), this.finishNode(e, "ImportDefaultSpecifier");
};
l.parseImportNamespaceSpecifier = function() {
  var e = this.startNode();
  return this.next(), this.expectContextual("as"), e.local = this.parseIdent(), this.checkLValSimple(e.local, D), this.finishNode(e, "ImportNamespaceSpecifier");
};
l.parseImportSpecifiers = function() {
  var e = [], t = !0;
  if (this.type === r.name && (e.push(this.parseImportDefaultSpecifier()), !this.eat(r.comma)))
    return e;
  if (this.type === r.star)
    return e.push(this.parseImportNamespaceSpecifier()), e;
  for (this.expect(r.braceL); !this.eat(r.braceR); ) {
    if (t)
      t = !1;
    else if (this.expect(r.comma), this.afterTrailingComma(r.braceR))
      break;
    e.push(this.parseImportSpecifier());
  }
  return e;
};
l.parseWithClause = function() {
  var e = [];
  if (!this.eat(r._with))
    return e;
  this.expect(r.braceL);
  for (var t = {}, i = !0; !this.eat(r.braceR); ) {
    if (i)
      i = !1;
    else if (this.expect(r.comma), this.afterTrailingComma(r.braceR))
      break;
    var s = this.parseImportAttribute(), a = s.key.type === "Identifier" ? s.key.name : s.key.value;
    Q(t, a) && this.raiseRecoverable(s.key.start, "Duplicate attribute key '" + a + "'"), t[a] = !0, e.push(s);
  }
  return e;
};
l.parseImportAttribute = function() {
  var e = this.startNode();
  return e.key = this.type === r.string ? this.parseExprAtom() : this.parseIdent(this.options.allowReserved !== "never"), this.expect(r.colon), this.type !== r.string && this.unexpected(), e.value = this.parseExprAtom(), this.finishNode(e, "ImportAttribute");
};
l.parseModuleExportName = function() {
  if (this.options.ecmaVersion >= 13 && this.type === r.string) {
    var e = this.parseLiteral(this.value);
    return wt.test(e.value) && this.raise(e.start, "An export name cannot include a lone surrogate."), e;
  }
  return this.parseIdent(!0);
};
l.adaptDirectivePrologue = function(e) {
  for (var t = 0; t < e.length && this.isDirectiveCandidate(e[t]); ++t)
    e[t].directive = e[t].expression.raw.slice(1, -1);
};
l.isDirectiveCandidate = function(e) {
  return this.options.ecmaVersion >= 5 && e.type === "ExpressionStatement" && e.expression.type === "Literal" && typeof e.expression.value == "string" && // Reject parenthesized strings.
  (this.input[e.start] === '"' || this.input[e.start] === "'");
};
var V = _.prototype;
V.toAssignable = function(e, t, i) {
  if (this.options.ecmaVersion >= 6 && e)
    switch (e.type) {
      case "Identifier":
        this.inAsync && e.name === "await" && this.raise(e.start, "Cannot use 'await' as identifier inside an async function");
        break;
      case "ObjectPattern":
      case "ArrayPattern":
      case "AssignmentPattern":
      case "RestElement":
        break;
      case "ObjectExpression":
        e.type = "ObjectPattern", i && this.checkPatternErrors(i, !0);
        for (var s = 0, a = e.properties; s < a.length; s += 1) {
          var n = a[s];
          this.toAssignable(n, t), n.type === "RestElement" && (n.argument.type === "ArrayPattern" || n.argument.type === "ObjectPattern") && this.raise(n.argument.start, "Unexpected token");
        }
        break;
      case "Property":
        e.kind !== "init" && this.raise(e.key.start, "Object pattern can't contain getter or setter"), this.toAssignable(e.value, t);
        break;
      case "ArrayExpression":
        e.type = "ArrayPattern", i && this.checkPatternErrors(i, !0), this.toAssignableList(e.elements, t);
        break;
      case "SpreadElement":
        e.type = "RestElement", this.toAssignable(e.argument, t), e.argument.type === "AssignmentPattern" && this.raise(e.argument.start, "Rest elements cannot have a default value");
        break;
      case "AssignmentExpression":
        e.operator !== "=" && this.raise(e.left.end, "Only '=' operator can be used for specifying default value."), e.type = "AssignmentPattern", delete e.operator, this.toAssignable(e.left, t);
        break;
      case "ParenthesizedExpression":
        this.toAssignable(e.expression, t, i);
        break;
      case "ChainExpression":
        this.raiseRecoverable(e.start, "Optional chaining cannot appear in left-hand side");
        break;
      case "MemberExpression":
        if (!t)
          break;
      default:
        this.raise(e.start, "Assigning to rvalue");
    }
  else i && this.checkPatternErrors(i, !0);
  return e;
};
V.toAssignableList = function(e, t) {
  for (var i = e.length, s = 0; s < i; s++) {
    var a = e[s];
    a && this.toAssignable(a, t);
  }
  if (i) {
    var n = e[i - 1];
    this.options.ecmaVersion === 6 && t && n && n.type === "RestElement" && n.argument.type !== "Identifier" && this.unexpected(n.argument.start);
  }
  return e;
};
V.parseSpread = function(e) {
  var t = this.startNode();
  return this.next(), t.argument = this.parseMaybeAssign(!1, e), this.finishNode(t, "SpreadElement");
};
V.parseRestBinding = function() {
  var e = this.startNode();
  return this.next(), this.options.ecmaVersion === 6 && this.type !== r.name && this.unexpected(), e.argument = this.parseBindingAtom(), this.finishNode(e, "RestElement");
};
V.parseBindingAtom = function() {
  if (this.options.ecmaVersion >= 6)
    switch (this.type) {
      case r.bracketL:
        var e = this.startNode();
        return this.next(), e.elements = this.parseBindingList(r.bracketR, !0, !0), this.finishNode(e, "ArrayPattern");
      case r.braceL:
        return this.parseObj(!0);
    }
  return this.parseIdent();
};
V.parseBindingList = function(e, t, i, s) {
  for (var a = [], n = !0; !this.eat(e); )
    if (n ? n = !1 : this.expect(r.comma), t && this.type === r.comma)
      a.push(null);
    else {
      if (i && this.afterTrailingComma(e))
        break;
      if (this.type === r.ellipsis) {
        var o = this.parseRestBinding();
        this.parseBindingListItem(o), a.push(o), this.type === r.comma && this.raiseRecoverable(this.start, "Comma is not permitted after the rest element"), this.expect(e);
        break;
      } else
        a.push(this.parseAssignableListItem(s));
    }
  return a;
};
V.parseAssignableListItem = function(e) {
  var t = this.parseMaybeDefault(this.start, this.startLoc);
  return this.parseBindingListItem(t), t;
};
V.parseBindingListItem = function(e) {
  return e;
};
V.parseMaybeDefault = function(e, t, i) {
  if (i = i || this.parseBindingAtom(), this.options.ecmaVersion < 6 || !this.eat(r.eq))
    return i;
  var s = this.startNodeAt(e, t);
  return s.left = i, s.right = this.parseMaybeAssign(), this.finishNode(s, "AssignmentPattern");
};
V.checkLValSimple = function(e, t, i) {
  t === void 0 && (t = ie);
  var s = t !== ie;
  switch (e.type) {
    case "Identifier":
      this.strict && this.reservedWordsStrictBind.test(e.name) && this.raiseRecoverable(e.start, (s ? "Binding " : "Assigning to ") + e.name + " in strict mode"), s && (t === D && e.name === "let" && this.raiseRecoverable(e.start, "let is disallowed as a lexically bound name"), i && (Q(i, e.name) && this.raiseRecoverable(e.start, "Argument name clash"), i[e.name] = !0), t !== ze && this.declareName(e.name, t, e.start));
      break;
    case "ChainExpression":
      this.raiseRecoverable(e.start, "Optional chaining cannot appear in left-hand side");
      break;
    case "MemberExpression":
      s && this.raiseRecoverable(e.start, "Binding member expression");
      break;
    case "ParenthesizedExpression":
      return s && this.raiseRecoverable(e.start, "Binding parenthesized expression"), this.checkLValSimple(e.expression, t, i);
    default:
      this.raise(e.start, (s ? "Binding" : "Assigning to") + " rvalue");
  }
};
V.checkLValPattern = function(e, t, i) {
  switch (t === void 0 && (t = ie), e.type) {
    case "ObjectPattern":
      for (var s = 0, a = e.properties; s < a.length; s += 1) {
        var n = a[s];
        this.checkLValInnerPattern(n, t, i);
      }
      break;
    case "ArrayPattern":
      for (var o = 0, u = e.elements; o < u.length; o += 1) {
        var h = u[o];
        h && this.checkLValInnerPattern(h, t, i);
      }
      break;
    default:
      this.checkLValSimple(e, t, i);
  }
};
V.checkLValInnerPattern = function(e, t, i) {
  switch (t === void 0 && (t = ie), e.type) {
    case "Property":
      this.checkLValInnerPattern(e.value, t, i);
      break;
    case "AssignmentPattern":
      this.checkLValPattern(e.left, t, i);
      break;
    case "RestElement":
      this.checkLValPattern(e.argument, t, i);
      break;
    default:
      this.checkLValPattern(e, t, i);
  }
};
var T = function(t, i, s, a, n) {
  this.token = t, this.isExpr = !!i, this.preserveSpace = !!s, this.override = a, this.generator = !!n;
}, y = {
  b_stat: new T("{", !1),
  b_expr: new T("{", !0),
  b_tmpl: new T("${", !1),
  p_stat: new T("(", !1),
  p_expr: new T("(", !0),
  q_tmpl: new T("`", !0, !0, function(e) {
    return e.tryReadTemplateToken();
  }),
  f_stat: new T("function", !1),
  f_expr: new T("function", !0),
  f_expr_gen: new T("function", !0, !1, null, !0),
  f_gen: new T("function", !1, !1, null, !0)
}, Y = _.prototype;
Y.initialContext = function() {
  return [y.b_stat];
};
Y.curContext = function() {
  return this.context[this.context.length - 1];
};
Y.braceIsBlock = function(e) {
  var t = this.curContext();
  return t === y.f_expr || t === y.f_stat ? !0 : e === r.colon && (t === y.b_stat || t === y.b_expr) ? !t.isExpr : e === r._return || e === r.name && this.exprAllowed ? w.test(this.input.slice(this.lastTokEnd, this.start)) : e === r._else || e === r.semi || e === r.eof || e === r.parenR || e === r.arrow ? !0 : e === r.braceL ? t === y.b_stat : e === r._var || e === r._const || e === r.name ? !1 : !this.exprAllowed;
};
Y.inGeneratorContext = function() {
  for (var e = this.context.length - 1; e >= 1; e--) {
    var t = this.context[e];
    if (t.token === "function")
      return t.generator;
  }
  return !1;
};
Y.updateContext = function(e) {
  var t, i = this.type;
  i.keyword && e === r.dot ? this.exprAllowed = !1 : (t = i.updateContext) ? t.call(this, e) : this.exprAllowed = i.beforeExpr;
};
Y.overrideContext = function(e) {
  this.curContext() !== e && (this.context[this.context.length - 1] = e);
};
r.parenR.updateContext = r.braceR.updateContext = function() {
  if (this.context.length === 1) {
    this.exprAllowed = !0;
    return;
  }
  var e = this.context.pop();
  e === y.b_stat && this.curContext().token === "function" && (e = this.context.pop()), this.exprAllowed = !e.isExpr;
};
r.braceL.updateContext = function(e) {
  this.context.push(this.braceIsBlock(e) ? y.b_stat : y.b_expr), this.exprAllowed = !0;
};
r.dollarBraceL.updateContext = function() {
  this.context.push(y.b_tmpl), this.exprAllowed = !0;
};
r.parenL.updateContext = function(e) {
  var t = e === r._if || e === r._for || e === r._with || e === r._while;
  this.context.push(t ? y.p_stat : y.p_expr), this.exprAllowed = !0;
};
r.incDec.updateContext = function() {
};
r._function.updateContext = r._class.updateContext = function(e) {
  e.beforeExpr && e !== r._else && !(e === r.semi && this.curContext() !== y.p_stat) && !(e === r._return && w.test(this.input.slice(this.lastTokEnd, this.start))) && !((e === r.colon || e === r.braceL) && this.curContext() === y.b_stat) ? this.context.push(y.f_expr) : this.context.push(y.f_stat), this.exprAllowed = !1;
};
r.colon.updateContext = function() {
  this.curContext().token === "function" && this.context.pop(), this.exprAllowed = !0;
};
r.backQuote.updateContext = function() {
  this.curContext() === y.q_tmpl ? this.context.pop() : this.context.push(y.q_tmpl), this.exprAllowed = !1;
};
r.star.updateContext = function(e) {
  if (e === r._function) {
    var t = this.context.length - 1;
    this.context[t] === y.f_expr ? this.context[t] = y.f_expr_gen : this.context[t] = y.f_gen;
  }
  this.exprAllowed = !0;
};
r.name.updateContext = function(e) {
  var t = !1;
  this.options.ecmaVersion >= 6 && e !== r.dot && (this.value === "of" && !this.exprAllowed || this.value === "yield" && this.inGeneratorContext()) && (t = !0), this.exprAllowed = t;
};
var f = _.prototype;
f.checkPropClash = function(e, t, i) {
  if (!(this.options.ecmaVersion >= 9 && e.type === "SpreadElement") && !(this.options.ecmaVersion >= 6 && (e.computed || e.method || e.shorthand))) {
    var s = e.key, a;
    switch (s.type) {
      case "Identifier":
        a = s.name;
        break;
      case "Literal":
        a = String(s.value);
        break;
      default:
        return;
    }
    var n = e.kind;
    if (this.options.ecmaVersion >= 6) {
      a === "__proto__" && n === "init" && (t.proto && (i ? i.doubleProto < 0 && (i.doubleProto = s.start) : this.raiseRecoverable(s.start, "Redefinition of __proto__ property")), t.proto = !0);
      return;
    }
    a = "$" + a;
    var o = t[a];
    if (o) {
      var u;
      n === "init" ? u = this.strict && o.init || o.get || o.set : u = o.init || o[n], u && this.raiseRecoverable(s.start, "Redefinition of property");
    } else
      o = t[a] = {
        init: !1,
        get: !1,
        set: !1
      };
    o[n] = !0;
  }
};
f.parseExpression = function(e, t) {
  var i = this;
  return this.catchStackOverflow(function() {
    var s = i.start, a = i.startLoc, n = i.parseMaybeAssign(e, t);
    if (i.type === r.comma) {
      var o = i.startNodeAt(s, a);
      for (o.expressions = [n]; i.eat(r.comma); )
        o.expressions.push(i.parseMaybeAssign(e, t));
      return i.finishNode(o, "SequenceExpression");
    }
    return n;
  });
};
f.parseMaybeAssign = function(e, t, i) {
  if (this.isContextual("yield")) {
    if (this.inGenerator)
      return this.parseYield(e);
    this.exprAllowed = !1;
  }
  var s = !1, a = -1, n = -1, o = -1;
  t ? (a = t.parenthesizedAssign, n = t.trailingComma, o = t.doubleProto, t.parenthesizedAssign = t.trailingComma = -1) : (t = new he(), s = !0);
  var u = this.start, h = this.startLoc;
  (this.type === r.parenL || this.type === r.name) && (this.potentialArrowAt = this.start, this.potentialArrowInForAwait = e === "await");
  var p = this.parseMaybeConditional(e, t);
  if (i && (p = i.call(this, p, u, h)), this.type.isAssign) {
    var d = this.startNodeAt(u, h);
    return d.operator = this.value, this.type === r.eq && (p = this.toAssignable(p, !1, t)), s || (t.parenthesizedAssign = t.trailingComma = t.doubleProto = -1), t.shorthandAssign >= p.start && (t.shorthandAssign = -1), this.type === r.eq ? this.checkLValPattern(p) : this.checkLValSimple(p), d.left = p, this.next(), d.right = this.parseMaybeAssign(e), o > -1 && (t.doubleProto = o), this.finishNode(d, "AssignmentExpression");
  } else
    s && this.checkExpressionErrors(t, !0);
  return a > -1 && (t.parenthesizedAssign = a), n > -1 && (t.trailingComma = n), p;
};
f.parseMaybeConditional = function(e, t) {
  var i = this.start, s = this.startLoc, a = this.parseExprOps(e, t);
  if (this.checkExpressionErrors(t))
    return a;
  if (!(a.type === "ArrowFunctionExpression" && a.start === i) && this.eat(r.question)) {
    var n = this.startNodeAt(i, s);
    return n.test = a, n.consequent = this.parseMaybeAssign(), this.expect(r.colon), n.alternate = this.parseMaybeAssign(e), this.finishNode(n, "ConditionalExpression");
  }
  return a;
};
f.parseExprOps = function(e, t) {
  var i = this.start, s = this.startLoc, a = this.parseMaybeUnary(t, !1, !1, e);
  return this.checkExpressionErrors(t) || a.start === i && a.type === "ArrowFunctionExpression" ? a : this.parseExprOp(a, i, s, -1, e);
};
f.parseExprOp = function(e, t, i, s, a) {
  var n = this.type.binop;
  if (n != null && (!a || this.type !== r._in) && n > s) {
    var o = this.type === r.logicalOR || this.type === r.logicalAND, u = this.type === r.coalesce;
    u && (n = r.logicalAND.binop);
    var h = this.value;
    this.next();
    var p = this.start, d = this.startLoc, b = this.parseExprOp(this.parseMaybeUnary(null, !1, !1, a), p, d, n, a), x = this.buildBinary(t, i, e, b, h, o || u);
    return (o && this.type === r.coalesce || u && (this.type === r.logicalOR || this.type === r.logicalAND)) && this.raiseRecoverable(this.start, "Logical expressions and coalesce expressions cannot be mixed. Wrap either by parentheses"), this.parseExprOp(x, t, i, s, a);
  }
  return e;
};
f.buildBinary = function(e, t, i, s, a, n) {
  s.type === "PrivateIdentifier" && this.raise(s.start, "Private identifier can only be left side of binary expression");
  var o = this.startNodeAt(e, t);
  return o.left = i, o.operator = a, o.right = s, this.finishNode(o, n ? "LogicalExpression" : "BinaryExpression");
};
f.parseMaybeUnary = function(e, t, i, s) {
  var a = this.start, n = this.startLoc, o;
  if (this.isContextual("await") && this.canAwait)
    o = this.parseAwait(s), t = !0;
  else if (this.type.prefix) {
    var u = this.startNode(), h = this.type === r.incDec;
    u.operator = this.value, u.prefix = !0, this.next(), u.argument = this.parseMaybeUnary(null, !0, h, s), this.checkExpressionErrors(e, !0), h ? this.checkLValSimple(u.argument) : this.strict && u.operator === "delete" && Qe(u.argument) ? this.raiseRecoverable(u.start, "Deleting local variable in strict mode") : u.operator === "delete" && be(u.argument) ? this.raiseRecoverable(u.start, "Private fields can not be deleted") : t = !0, o = this.finishNode(u, h ? "UpdateExpression" : "UnaryExpression");
  } else if (!t && this.type === r.privateId)
    (s || this.privateNameStack.length === 0) && this.options.checkPrivateFields && this.unexpected(), o = this.parsePrivateIdent(), this.type !== r._in && this.unexpected();
  else {
    if (o = this.parseExprSubscripts(e, s), this.checkExpressionErrors(e))
      return o;
    for (; this.type.postfix && !this.canInsertSemicolon(); ) {
      var p = this.startNodeAt(a, n);
      p.operator = this.value, p.prefix = !1, p.argument = o, this.checkLValSimple(o), this.next(), o = this.finishNode(p, "UpdateExpression");
    }
  }
  if (!i && !(o.type === "ArrowFunctionExpression" && o.start === a) && this.eat(r.starstar))
    if (t)
      this.unexpected(this.lastTokStart);
    else
      return this.buildBinary(a, n, o, this.parseMaybeUnary(null, !1, !1, s), "**", !1);
  else
    return o;
};
function Qe(e) {
  return e.type === "Identifier" || e.type === "ParenthesizedExpression" && Qe(e.expression);
}
function be(e) {
  return e.type === "MemberExpression" && e.property.type === "PrivateIdentifier" || e.type === "ChainExpression" && be(e.expression) || e.type === "ParenthesizedExpression" && be(e.expression);
}
f.parseExprSubscripts = function(e, t) {
  var i = this.start, s = this.startLoc, a = this.parseExprAtom(e, t);
  if (a.type === "ArrowFunctionExpression" && this.input.slice(this.lastTokStart, this.lastTokEnd) !== ")")
    return a;
  var n = this.parseSubscripts(a, i, s, !1, t);
  return e && n.type === "MemberExpression" && (e.parenthesizedAssign >= n.start && (e.parenthesizedAssign = -1), e.parenthesizedBind >= n.start && (e.parenthesizedBind = -1), e.trailingComma >= n.start && (e.trailingComma = -1)), n;
};
f.parseSubscripts = function(e, t, i, s, a) {
  for (var n = this.options.ecmaVersion >= 8 && e.type === "Identifier" && e.name === "async" && this.lastTokEnd === e.end && !this.canInsertSemicolon() && e.end - e.start === 5 && this.potentialArrowAt === e.start, o = !1; ; ) {
    var u = this.parseSubscript(e, t, i, s, n, o, a);
    if (u.optional && (o = !0), u === e || u.type === "ArrowFunctionExpression") {
      if (o) {
        var h = this.startNodeAt(t, i);
        h.expression = u, u = this.finishNode(h, "ChainExpression");
      }
      return u;
    }
    e = u;
  }
};
f.shouldParseAsyncArrow = function() {
  return !this.canInsertSemicolon() && this.eat(r.arrow);
};
f.parseSubscriptAsyncArrow = function(e, t, i, s) {
  return this.parseArrowExpression(this.startNodeAt(e, t), i, !0, s);
};
f.parseSubscript = function(e, t, i, s, a, n, o) {
  var u = this.options.ecmaVersion >= 11, h = u && this.eat(r.questionDot);
  s && h && this.raise(this.lastTokStart, "Optional chaining cannot appear in the callee of new expressions");
  var p = this.eat(r.bracketL);
  if (p || h && this.type !== r.parenL && this.type !== r.backQuote || this.eat(r.dot)) {
    var d = this.startNodeAt(t, i);
    d.object = e, p ? (d.property = this.parseExpression(), this.expect(r.bracketR)) : this.type === r.privateId && e.type !== "Super" ? d.property = this.parsePrivateIdent() : d.property = this.parseIdent(this.options.allowReserved !== "never"), d.computed = !!p, u && (d.optional = h), e = this.finishNode(d, "MemberExpression");
  } else if (!s && this.eat(r.parenL)) {
    var b = new he(), x = this.yieldPos, E = this.awaitPos, F = this.awaitIdentPos;
    this.yieldPos = 0, this.awaitPos = 0, this.awaitIdentPos = 0;
    var ee = this.parseExprList(r.parenR, this.options.ecmaVersion >= 8, !1, b);
    if (a && !h && this.shouldParseAsyncArrow())
      return this.checkPatternErrors(b, !1), this.checkYieldAwaitInDefaultParams(), this.awaitIdentPos > 0 && this.raise(this.awaitIdentPos, "Cannot use 'await' as identifier inside an async function"), this.yieldPos = x, this.awaitPos = E, this.awaitIdentPos = F, this.parseSubscriptAsyncArrow(t, i, ee, o);
    this.checkExpressionErrors(b, !0), this.yieldPos = x || this.yieldPos, this.awaitPos = E || this.awaitPos, this.awaitIdentPos = F || this.awaitIdentPos;
    var H = this.startNodeAt(t, i);
    H.callee = e, H.arguments = ee, u && (H.optional = h), e = this.finishNode(H, "CallExpression");
  } else if (this.type === r.backQuote) {
    (h || n) && this.raise(this.start, "Optional chaining cannot appear in the tag of tagged template expressions");
    var z = this.startNodeAt(t, i);
    z.tag = e, z.quasi = this.parseTemplate({ isTagged: !0 }), e = this.finishNode(z, "TaggedTemplateExpression");
  }
  return e;
};
f.parseExprAtom = function(e, t, i) {
  this.type === r.slash && this.readRegexp();
  var s, a = this.potentialArrowAt === this.start;
  switch (this.type) {
    case r._super:
      return this.allowSuper || this.raise(this.start, "'super' keyword outside a method"), s = this.startNode(), this.next(), this.type === r.parenL && !this.allowDirectSuper && this.raise(s.start, "super() call outside constructor of a subclass"), this.type !== r.dot && this.type !== r.bracketL && this.type !== r.parenL && this.unexpected(), this.finishNode(s, "Super");
    case r._this:
      return s = this.startNode(), this.next(), this.finishNode(s, "ThisExpression");
    case r.name:
      var n = this.start, o = this.startLoc, u = this.containsEsc, h = this.parseIdent(!1);
      if (this.options.ecmaVersion >= 8 && !u && h.name === "async" && !this.canInsertSemicolon() && this.eat(r._function))
        return this.overrideContext(y.f_expr), this.parseFunction(this.startNodeAt(n, o), 0, !1, !0, t);
      if (a && !this.canInsertSemicolon()) {
        if (this.eat(r.arrow))
          return this.parseArrowExpression(this.startNodeAt(n, o), [h], !1, t);
        if (this.options.ecmaVersion >= 8 && h.name === "async" && this.type === r.name && !u && (!this.potentialArrowInForAwait || this.value !== "of" || this.containsEsc))
          return h = this.parseIdent(!1), (this.canInsertSemicolon() || !this.eat(r.arrow)) && this.unexpected(), this.parseArrowExpression(this.startNodeAt(n, o), [h], !0, t);
      }
      return h;
    case r.regexp:
      var p = this.value;
      return s = this.parseLiteral(p.value), s.regex = { pattern: p.pattern, flags: p.flags }, s;
    case r.num:
    case r.string:
      return this.parseLiteral(this.value);
    case r._null:
    case r._true:
    case r._false:
      return s = this.startNode(), s.value = this.type === r._null ? null : this.type === r._true, s.raw = this.type.keyword, this.next(), this.finishNode(s, "Literal");
    case r.parenL:
      var d = this.start, b = this.parseParenAndDistinguishExpression(a, t);
      return e && (e.parenthesizedAssign < 0 && !this.isSimpleAssignTarget(b) && (e.parenthesizedAssign = d), e.parenthesizedBind < 0 && (e.parenthesizedBind = d)), b;
    case r.bracketL:
      return s = this.startNode(), this.next(), s.elements = this.parseExprList(r.bracketR, !0, !0, e), this.finishNode(s, "ArrayExpression");
    case r.braceL:
      return this.overrideContext(y.b_expr), this.parseObj(!1, e);
    case r._function:
      return s = this.startNode(), this.next(), this.parseFunction(s, 0);
    case r._class:
      return this.parseClass(this.startNode(), !1);
    case r._new:
      return this.parseNew();
    case r.backQuote:
      return this.parseTemplate();
    case r._import:
      return this.options.ecmaVersion >= 11 ? this.parseExprImport(i) : this.unexpected();
    default:
      return this.parseExprAtomDefault();
  }
};
f.parseExprAtomDefault = function() {
  this.unexpected();
};
f.parseExprImport = function(e) {
  var t = this.startNode();
  if (this.containsEsc && this.raiseRecoverable(this.start, "Escape sequence in keyword import"), this.next(), this.type === r.parenL && !e)
    return this.parseDynamicImport(t);
  if (this.type === r.dot) {
    var i = this.startNodeAt(t.start, t.loc && t.loc.start);
    return i.name = "import", t.meta = this.finishNode(i, "Identifier"), this.parseImportMeta(t);
  } else
    this.unexpected();
};
f.parseDynamicImport = function(e) {
  if (this.next(), e.source = this.parseMaybeAssign(), this.options.ecmaVersion >= 16)
    this.eat(r.parenR) ? e.options = null : (this.expect(r.comma), this.afterTrailingComma(r.parenR) ? e.options = null : (e.options = this.parseMaybeAssign(), this.eat(r.parenR) || (this.expect(r.comma), this.afterTrailingComma(r.parenR) || this.unexpected())));
  else if (!this.eat(r.parenR)) {
    var t = this.start;
    this.eat(r.comma) && this.eat(r.parenR) ? this.raiseRecoverable(t, "Trailing comma is not allowed in import()") : this.unexpected(t);
  }
  return this.finishNode(e, "ImportExpression");
};
f.parseImportMeta = function(e) {
  this.next();
  var t = this.containsEsc;
  return e.property = this.parseIdent(!0), e.property.name !== "meta" && this.raiseRecoverable(e.property.start, "The only valid meta property for import is 'import.meta'"), t && this.raiseRecoverable(e.start, "'import.meta' must not contain escaped characters"), this.options.sourceType !== "module" && !this.options.allowImportExportEverywhere && this.raiseRecoverable(e.start, "Cannot use 'import.meta' outside a module"), this.finishNode(e, "MetaProperty");
};
f.parseLiteral = function(e) {
  var t = this.startNode();
  return t.value = e, t.raw = this.input.slice(this.start, this.end), t.raw.charCodeAt(t.raw.length - 1) === 110 && (t.bigint = t.value != null ? t.value.toString() : t.raw.slice(0, -1).replace(/_/g, "")), this.next(), this.finishNode(t, "Literal");
};
f.parseParenExpression = function() {
  this.expect(r.parenL);
  var e = this.parseExpression();
  return this.expect(r.parenR), e;
};
f.shouldParseArrow = function(e) {
  return !this.canInsertSemicolon();
};
f.parseParenAndDistinguishExpression = function(e, t) {
  var i = this.start, s = this.startLoc, a, n = this.options.ecmaVersion >= 8;
  if (this.options.ecmaVersion >= 6) {
    this.next();
    var o = this.start, u = this.startLoc, h = [], p = !0, d = !1, b = new he(), x = this.yieldPos, E = this.awaitPos, F;
    for (this.yieldPos = 0, this.awaitPos = 0; this.type !== r.parenR; )
      if (p ? p = !1 : this.expect(r.comma), n && this.afterTrailingComma(r.parenR, !0)) {
        d = !0;
        break;
      } else if (this.type === r.ellipsis) {
        F = this.start, h.push(this.parseParenItem(this.parseRestBinding())), this.type === r.comma && this.raiseRecoverable(
          this.start,
          "Comma is not permitted after the rest element"
        );
        break;
      } else
        h.push(this.parseMaybeAssign(!1, b, this.parseParenItem));
    var ee = this.lastTokEnd, H = this.lastTokEndLoc;
    if (this.expect(r.parenR), e && this.shouldParseArrow(h) && this.eat(r.arrow))
      return this.checkPatternErrors(b, !1), this.checkYieldAwaitInDefaultParams(), this.yieldPos = x, this.awaitPos = E, this.parseParenArrowList(i, s, h, t);
    (!h.length || d) && this.unexpected(this.lastTokStart), F && this.unexpected(F), this.checkExpressionErrors(b, !0), this.yieldPos = x || this.yieldPos, this.awaitPos = E || this.awaitPos, h.length > 1 ? (a = this.startNodeAt(o, u), a.expressions = h, this.finishNodeAt(a, "SequenceExpression", ee, H)) : a = h[0];
  } else
    a = this.parseParenExpression();
  if (this.options.preserveParens) {
    var z = this.startNodeAt(i, s);
    return z.expression = a, this.finishNode(z, "ParenthesizedExpression");
  } else
    return a;
};
f.parseParenItem = function(e) {
  return e;
};
f.parseParenArrowList = function(e, t, i, s) {
  return this.parseArrowExpression(this.startNodeAt(e, t), i, !1, s);
};
var Tt = [];
f.parseNew = function() {
  this.containsEsc && this.raiseRecoverable(this.start, "Escape sequence in keyword new");
  var e = this.startNode();
  if (this.next(), this.options.ecmaVersion >= 6 && this.type === r.dot) {
    var t = this.startNodeAt(e.start, e.loc && e.loc.start);
    t.name = "new", e.meta = this.finishNode(t, "Identifier"), this.next();
    var i = this.containsEsc;
    return e.property = this.parseIdent(!0), e.property.name !== "target" && this.raiseRecoverable(e.property.start, "The only valid meta property for new is 'new.target'"), i && this.raiseRecoverable(e.start, "'new.target' must not contain escaped characters"), this.allowNewDotTarget || this.raiseRecoverable(e.start, "'new.target' can only be used in functions and class static block"), this.finishNode(e, "MetaProperty");
  }
  var s = this.start, a = this.startLoc;
  return e.callee = this.parseSubscripts(this.parseExprAtom(null, !1, !0), s, a, !0, !1), e.callee.type === "Super" && this.raiseRecoverable(s, "Invalid use of 'super'"), this.eat(r.parenL) ? e.arguments = this.parseExprList(r.parenR, this.options.ecmaVersion >= 8, !1) : e.arguments = Tt, this.finishNode(e, "NewExpression");
};
f.parseTemplateElement = function(e) {
  var t = e.isTagged, i = this.startNode();
  return this.type === r.invalidTemplate ? (t || this.raiseRecoverable(this.start, "Bad escape sequence in untagged template literal"), i.value = {
    raw: this.value.replace(/\r\n?/g, `
`),
    cooked: null
  }) : i.value = {
    raw: this.input.slice(this.start, this.end).replace(/\r\n?/g, `
`),
    cooked: this.value
  }, this.next(), i.tail = this.type === r.backQuote, this.finishNode(i, "TemplateElement");
};
f.parseTemplate = function(e) {
  e === void 0 && (e = {});
  var t = e.isTagged;
  t === void 0 && (t = !1);
  var i = this.startNode();
  this.next(), i.expressions = [];
  var s = this.parseTemplateElement({ isTagged: t });
  for (i.quasis = [s]; !s.tail; )
    this.type === r.eof && this.raise(this.pos, "Unterminated template literal"), this.expect(r.dollarBraceL), i.expressions.push(this.parseExpression()), this.expect(r.braceR), i.quasis.push(s = this.parseTemplateElement({ isTagged: t }));
  return this.next(), this.finishNode(i, "TemplateLiteral");
};
f.isAsyncProp = function(e) {
  return !e.computed && e.key.type === "Identifier" && e.key.name === "async" && (this.type === r.name || this.type === r.num || this.type === r.string || this.type === r.bracketL || this.type.keyword || this.options.ecmaVersion >= 9 && this.type === r.star) && !w.test(this.input.slice(this.lastTokEnd, this.start));
};
f.parseObj = function(e, t) {
  var i = this.startNode(), s = !0, a = {};
  for (i.properties = [], this.next(); !this.eat(r.braceR); ) {
    if (s)
      s = !1;
    else if (this.expect(r.comma), this.options.ecmaVersion >= 5 && this.afterTrailingComma(r.braceR))
      break;
    var n = this.parseProperty(e, t);
    e || this.checkPropClash(n, a, t), i.properties.push(n);
  }
  return this.finishNode(i, e ? "ObjectPattern" : "ObjectExpression");
};
f.parseProperty = function(e, t) {
  var i = this.startNode(), s, a, n, o;
  if (this.options.ecmaVersion >= 9 && this.eat(r.ellipsis))
    return e ? (i.argument = this.parseIdent(!1), this.type === r.comma && this.raiseRecoverable(this.start, "Comma is not permitted after the rest element"), this.finishNode(i, "RestElement")) : (i.argument = this.parseMaybeAssign(!1, t), this.type === r.comma && t && t.trailingComma < 0 && (t.trailingComma = this.start), this.finishNode(i, "SpreadElement"));
  this.options.ecmaVersion >= 6 && (i.method = !1, i.shorthand = !1, (e || t) && (n = this.start, o = this.startLoc), e || (s = this.eat(r.star)));
  var u = this.containsEsc;
  return this.parsePropertyName(i), !e && !u && this.options.ecmaVersion >= 8 && !s && this.isAsyncProp(i) ? (a = !0, s = this.options.ecmaVersion >= 9 && this.eat(r.star), this.parsePropertyName(i)) : a = !1, this.parsePropertyValue(i, e, s, a, n, o, t, u), this.finishNode(i, "Property");
};
f.parseGetterSetter = function(e) {
  var t = e.key.name;
  this.parsePropertyName(e), e.value = this.parseMethod(!1), e.kind = t;
  var i = e.kind === "get" ? 0 : 1;
  if (e.value.params.length !== i) {
    var s = e.value.start;
    e.kind === "get" ? this.raiseRecoverable(s, "getter should have no params") : this.raiseRecoverable(s, "setter should have exactly one param");
  } else
    e.kind === "set" && e.value.params[0].type === "RestElement" && this.raiseRecoverable(e.value.params[0].start, "Setter cannot use rest params");
};
f.parsePropertyValue = function(e, t, i, s, a, n, o, u) {
  (i || s) && this.type === r.colon && this.unexpected(), this.eat(r.colon) ? (e.value = t ? this.parseMaybeDefault(this.start, this.startLoc) : this.parseMaybeAssign(!1, o), e.kind = "init") : this.options.ecmaVersion >= 6 && this.type === r.parenL ? (t && this.unexpected(), e.method = !0, e.value = this.parseMethod(i, s), e.kind = "init") : !t && !u && this.options.ecmaVersion >= 5 && !e.computed && e.key.type === "Identifier" && (e.key.name === "get" || e.key.name === "set") && this.type !== r.comma && this.type !== r.braceR && this.type !== r.eq ? ((i || s) && this.unexpected(), this.parseGetterSetter(e)) : this.options.ecmaVersion >= 6 && !e.computed && e.key.type === "Identifier" ? ((i || s) && this.unexpected(), this.checkUnreserved(e.key), e.key.name === "await" && !this.awaitIdentPos && (this.awaitIdentPos = a), t ? e.value = this.parseMaybeDefault(a, n, this.copyNode(e.key)) : this.type === r.eq && o ? (o.shorthandAssign < 0 && (o.shorthandAssign = this.start), e.value = this.parseMaybeDefault(a, n, this.copyNode(e.key))) : e.value = this.copyNode(e.key), e.kind = "init", e.shorthand = !0) : this.unexpected();
};
f.parsePropertyName = function(e) {
  if (this.options.ecmaVersion >= 6) {
    if (this.eat(r.bracketL))
      return e.computed = !0, e.key = this.parseMaybeAssign(), this.expect(r.bracketR), e.key;
    e.computed = !1;
  }
  return e.key = this.type === r.num || this.type === r.string ? this.parseExprAtom() : this.parseIdent(this.options.allowReserved !== "never");
};
f.initFunction = function(e) {
  e.id = null, this.options.ecmaVersion >= 6 && (e.generator = e.expression = !1), this.options.ecmaVersion >= 8 && (e.async = !1);
};
f.parseMethod = function(e, t, i) {
  var s = this.startNode(), a = this.yieldPos, n = this.awaitPos, o = this.awaitIdentPos;
  return this.initFunction(s), this.options.ecmaVersion >= 6 && (s.generator = e), this.options.ecmaVersion >= 8 && (s.async = !!t), this.yieldPos = 0, this.awaitPos = 0, this.awaitIdentPos = 0, this.enterScope(Ce(t, s.generator) | oe | (i ? qe : 0)), this.expect(r.parenL), s.params = this.parseBindingList(r.parenR, !1, this.options.ecmaVersion >= 8), this.checkYieldAwaitInDefaultParams(), this.parseFunctionBody(s, !1, !0, !1), this.yieldPos = a, this.awaitPos = n, this.awaitIdentPos = o, this.finishNode(s, "FunctionExpression");
};
f.parseArrowExpression = function(e, t, i, s) {
  var a = this.yieldPos, n = this.awaitPos, o = this.awaitIdentPos;
  return this.enterScope(Ce(i, !1) | Se), this.initFunction(e), this.options.ecmaVersion >= 8 && (e.async = !!i), this.yieldPos = 0, this.awaitPos = 0, this.awaitIdentPos = 0, e.params = this.toAssignableList(t, !0), this.parseFunctionBody(e, !0, !1, s), this.yieldPos = a, this.awaitPos = n, this.awaitIdentPos = o, this.finishNode(e, "ArrowFunctionExpression");
};
f.parseFunctionBody = function(e, t, i, s) {
  var a = t && this.type !== r.braceL, n = this.strict, o = !1;
  if (a)
    e.body = this.parseMaybeAssign(s), e.expression = !0, this.checkParams(e, !1);
  else {
    var u = this.options.ecmaVersion >= 7 && !this.isSimpleParamList(e.params);
    (!n || u) && (o = this.strictDirective(this.end), o && u && this.raiseRecoverable(e.start, "Illegal 'use strict' directive in function with non-simple parameter list"));
    var h = this.labels;
    this.labels = [], o && (this.strict = !0), this.checkParams(e, !n && !o && !t && !i && this.isSimpleParamList(e.params)), this.strict && e.id && this.checkLValSimple(e.id, ze), e.body = this.parseBlock(!1, void 0, o && !n), e.expression = !1, this.adaptDirectivePrologue(e.body.body), this.labels = h;
  }
  this.exitScope();
};
f.isSimpleParamList = function(e) {
  for (var t = 0, i = e; t < i.length; t += 1) {
    var s = i[t];
    if (s.type !== "Identifier")
      return !1;
  }
  return !0;
};
f.checkParams = function(e, t) {
  for (var i = /* @__PURE__ */ Object.create(null), s = 0, a = e.params; s < a.length; s += 1) {
    var n = a[s];
    this.checkLValInnerPattern(n, ke, t ? null : i);
  }
};
f.parseExprList = function(e, t, i, s) {
  for (var a = [], n = !0; !this.eat(e); ) {
    if (n)
      n = !1;
    else if (this.expect(r.comma), t && this.afterTrailingComma(e))
      break;
    var o = void 0;
    i && this.type === r.comma ? o = null : this.type === r.ellipsis ? (o = this.parseSpread(s), s && this.type === r.comma && s.trailingComma < 0 && (s.trailingComma = this.start)) : o = this.parseMaybeAssign(!1, s), a.push(o);
  }
  return a;
};
f.checkUnreserved = function(e) {
  var t = e.start, i = e.end, s = e.name;
  if (this.inGenerator && s === "yield" && this.raiseRecoverable(t, "Cannot use 'yield' as identifier inside a generator"), this.inAsync && s === "await" && this.raiseRecoverable(t, "Cannot use 'await' as identifier inside an async function"), !(this.currentThisScope().flags & ue) && s === "arguments" && this.raiseRecoverable(t, "Cannot use 'arguments' in class field initializer"), this.inClassStaticBlock && (s === "arguments" || s === "await") && this.raise(t, "Cannot use " + s + " in class static initialization block"), this.keywords.test(s) && this.raise(t, "Unexpected keyword '" + s + "'"), !(this.options.ecmaVersion < 6 && this.input.slice(t, i).indexOf("\\") !== -1)) {
    var a = this.strict ? this.reservedWordsStrict : this.reservedWords;
    a.test(s) && (!this.inAsync && s === "await" && this.raiseRecoverable(t, "Cannot use keyword 'await' outside an async function"), this.raiseRecoverable(t, "The keyword '" + s + "' is reserved"));
  }
};
f.parseIdent = function(e) {
  var t = this.parseIdentNode();
  return this.next(!!e), this.finishNode(t, "Identifier"), e || (this.checkUnreserved(t), t.name === "await" && !this.awaitIdentPos && (this.awaitIdentPos = t.start)), t;
};
f.parseIdentNode = function() {
  var e = this.startNode();
  return this.type === r.name ? e.name = this.value : this.type.keyword ? (e.name = this.type.keyword, (e.name === "class" || e.name === "function") && (this.lastTokEnd !== this.lastTokStart + 1 || this.input.charCodeAt(this.lastTokStart) !== 46) && this.context.pop(), this.type = r.name) : this.unexpected(), e;
};
f.parsePrivateIdent = function() {
  var e = this.startNode();
  return this.type === r.privateId ? e.name = this.value : this.unexpected(), this.next(), this.finishNode(e, "PrivateIdentifier"), this.options.checkPrivateFields && (this.privateNameStack.length === 0 ? this.raise(e.start, "Private field '#" + e.name + "' must be declared in an enclosing class") : this.privateNameStack[this.privateNameStack.length - 1].used.push(e)), e;
};
f.parseYield = function(e) {
  this.yieldPos || (this.yieldPos = this.start);
  var t = this.startNode();
  return this.next(), this.type === r.semi || this.canInsertSemicolon() || this.type !== r.star && !this.type.startsExpr ? (t.delegate = !1, t.argument = null) : (t.delegate = this.eat(r.star), t.argument = this.parseMaybeAssign(e)), this.finishNode(t, "YieldExpression");
};
f.parseAwait = function(e) {
  this.awaitPos || (this.awaitPos = this.start);
  var t = this.startNode();
  return this.next(), t.argument = this.parseMaybeUnary(null, !0, !1, e), this.finishNode(t, "AwaitExpression");
};
var re = _.prototype;
re.raise = function(e, t) {
  var i = Me(this.input, e);
  t += " (" + i.line + ":" + i.column + ")", this.sourceFile && (t += " in " + this.sourceFile);
  var s = new SyntaxError(t);
  throw s.pos = e, s.loc = i, s.raisedAt = this.pos, s;
};
re.raiseRecoverable = re.raise;
re.curPosition = function() {
  if (this.options.locations)
    return new Z(this.curLine, this.pos - this.lineStart);
};
var j = _.prototype, Lt = function(t) {
  this.flags = t, this.var = [], this.lexical = [], this.functions = [];
};
j.enterScope = function(e) {
  this.scopeStack.push(new Lt(e));
};
j.exitScope = function() {
  this.scopeStack.pop();
};
j.treatFunctionsAsVarInScope = function(e) {
  return e.flags & G || !this.inModule && e.flags & q;
};
j.declareName = function(e, t, i) {
  var s = !1;
  if (t === D) {
    var a = this.currentScope();
    s = a.lexical.indexOf(e) > -1 || a.functions.indexOf(e) > -1 || a.var.indexOf(e) > -1, a.lexical.push(e), this.inModule && a.flags & q && delete this.undefinedExports[e];
  } else if (t === He) {
    var n = this.currentScope();
    n.lexical.push(e);
  } else if (t === We) {
    var o = this.currentScope();
    this.treatFunctionsAsVar ? s = o.lexical.indexOf(e) > -1 : s = o.lexical.indexOf(e) > -1 || o.var.indexOf(e) > -1, o.functions.push(e);
  } else
    for (var u = this.scopeStack.length - 1; u >= 0; --u) {
      var h = this.scopeStack[u];
      if (h.lexical.indexOf(e) > -1 && !(h.flags & je && h.lexical[0] === e) || !this.treatFunctionsAsVarInScope(h) && h.functions.indexOf(e) > -1) {
        s = !0;
        break;
      }
      if (h.var.push(e), this.inModule && h.flags & q && delete this.undefinedExports[e], h.flags & ue)
        break;
    }
  s && this.raiseRecoverable(i, "Identifier '" + e + "' has already been declared");
};
j.checkLocalExport = function(e) {
  this.scopeStack[0].lexical.indexOf(e.name) === -1 && this.scopeStack[0].var.indexOf(e.name) === -1 && (this.undefinedExports[e.name] = e);
};
j.currentScope = function() {
  return this.scopeStack[this.scopeStack.length - 1];
};
j.currentVarScope = function() {
  for (var e = this.scopeStack.length - 1; ; e--) {
    var t = this.scopeStack[e];
    if (t.flags & (ue | J | W))
      return t;
  }
};
j.currentThisScope = function() {
  for (var e = this.scopeStack.length - 1; ; e--) {
    var t = this.scopeStack[e];
    if (t.flags & (ue | J | W) && !(t.flags & Se))
      return t;
  }
};
var ce = function(t, i, s) {
  this.type = "", this.start = i, this.end = 0, t.options.locations && (this.loc = new ne(t, s)), t.options.directSourceFile && (this.sourceFile = t.options.directSourceFile), t.options.ranges && (this.range = [i, 0]);
}, $ = _.prototype;
$.startNode = function() {
  return new ce(this, this.start, this.startLoc);
};
$.startNodeAt = function(e, t) {
  return new ce(this, e, t);
};
function Ye(e, t, i, s) {
  return e.type = t, e.end = i, this.options.locations && (e.loc.end = s), this.options.ranges && (e.range[1] = i), e;
}
$.finishNode = function(e, t) {
  return Ye.call(this, e, t, this.lastTokEnd, this.lastTokEndLoc);
};
$.finishNodeAt = function(e, t, i, s) {
  return Ye.call(this, e, t, i, s);
};
$.copyNode = function(e) {
  var t = new ce(this, e.start, this.startLoc);
  for (var i in e)
    t[i] = e[i];
  return t;
};
var Rt = "Berf Beria_Erfe Gara Garay Gukh Gurung_Khema Hrkt Katakana_Or_Hiragana Kawi Kirat_Rai Krai Nag_Mundari Nagm Ol_Onal Onao Sidetic Sidt Sunu Sunuwar Tai_Yo Tayo Todhri Todr Tolong_Siki Tols Tulu_Tigalari Tutg Unknown Zzzz", Xe = "ASCII ASCII_Hex_Digit AHex Alphabetic Alpha Any Assigned Bidi_Control Bidi_C Bidi_Mirrored Bidi_M Case_Ignorable CI Cased Changes_When_Casefolded CWCF Changes_When_Casemapped CWCM Changes_When_Lowercased CWL Changes_When_NFKC_Casefolded CWKCF Changes_When_Titlecased CWT Changes_When_Uppercased CWU Dash Default_Ignorable_Code_Point DI Deprecated Dep Diacritic Dia Emoji Emoji_Component Emoji_Modifier Emoji_Modifier_Base Emoji_Presentation Extender Ext Grapheme_Base Gr_Base Grapheme_Extend Gr_Ext Hex_Digit Hex IDS_Binary_Operator IDSB IDS_Trinary_Operator IDST ID_Continue IDC ID_Start IDS Ideographic Ideo Join_Control Join_C Logical_Order_Exception LOE Lowercase Lower Math Noncharacter_Code_Point NChar Pattern_Syntax Pat_Syn Pattern_White_Space Pat_WS Quotation_Mark QMark Radical Regional_Indicator RI Sentence_Terminal STerm Soft_Dotted SD Terminal_Punctuation Term Unified_Ideograph UIdeo Uppercase Upper Variation_Selector VS White_Space space XID_Continue XIDC XID_Start XIDS", Ze = Xe + " Extended_Pictographic", Je = Ze, $e = Je + " EBase EComp EMod EPres ExtPict", et = $e, Ot = et, Bt = {
  9: Xe,
  10: Ze,
  11: Je,
  12: $e,
  13: et,
  14: Ot
}, Dt = "Basic_Emoji Emoji_Keycap_Sequence RGI_Emoji_Modifier_Sequence RGI_Emoji_Flag_Sequence RGI_Emoji_Tag_Sequence RGI_Emoji_ZWJ_Sequence RGI_Emoji", Ft = {
  9: "",
  10: "",
  11: "",
  12: "",
  13: "",
  14: Dt
}, Ne = "Cased_Letter LC Close_Punctuation Pe Connector_Punctuation Pc Control Cc cntrl Currency_Symbol Sc Dash_Punctuation Pd Decimal_Number Nd digit Enclosing_Mark Me Final_Punctuation Pf Format Cf Initial_Punctuation Pi Letter L Letter_Number Nl Line_Separator Zl Lowercase_Letter Ll Mark M Combining_Mark Math_Symbol Sm Modifier_Letter Lm Modifier_Symbol Sk Nonspacing_Mark Mn Number N Open_Punctuation Ps Other C Other_Letter Lo Other_Number No Other_Punctuation Po Other_Symbol So Paragraph_Separator Zp Private_Use Co Punctuation P punct Separator Z Space_Separator Zs Spacing_Mark Mc Surrogate Cs Symbol S Titlecase_Letter Lt Unassigned Cn Uppercase_Letter Lu", tt = "Adlam Adlm Ahom Anatolian_Hieroglyphs Hluw Arabic Arab Armenian Armn Avestan Avst Balinese Bali Bamum Bamu Bassa_Vah Bass Batak Batk Bengali Beng Bhaiksuki Bhks Bopomofo Bopo Brahmi Brah Braille Brai Buginese Bugi Buhid Buhd Canadian_Aboriginal Cans Carian Cari Caucasian_Albanian Aghb Chakma Cakm Cham Cham Cherokee Cher Common Zyyy Coptic Copt Qaac Cuneiform Xsux Cypriot Cprt Cyrillic Cyrl Deseret Dsrt Devanagari Deva Duployan Dupl Egyptian_Hieroglyphs Egyp Elbasan Elba Ethiopic Ethi Georgian Geor Glagolitic Glag Gothic Goth Grantha Gran Greek Grek Gujarati Gujr Gurmukhi Guru Han Hani Hangul Hang Hanunoo Hano Hatran Hatr Hebrew Hebr Hiragana Hira Imperial_Aramaic Armi Inherited Zinh Qaai Inscriptional_Pahlavi Phli Inscriptional_Parthian Prti Javanese Java Kaithi Kthi Kannada Knda Katakana Kana Kayah_Li Kali Kharoshthi Khar Khmer Khmr Khojki Khoj Khudawadi Sind Lao Laoo Latin Latn Lepcha Lepc Limbu Limb Linear_A Lina Linear_B Linb Lisu Lisu Lycian Lyci Lydian Lydi Mahajani Mahj Malayalam Mlym Mandaic Mand Manichaean Mani Marchen Marc Masaram_Gondi Gonm Meetei_Mayek Mtei Mende_Kikakui Mend Meroitic_Cursive Merc Meroitic_Hieroglyphs Mero Miao Plrd Modi Mongolian Mong Mro Mroo Multani Mult Myanmar Mymr Nabataean Nbat New_Tai_Lue Talu Newa Newa Nko Nkoo Nushu Nshu Ogham Ogam Ol_Chiki Olck Old_Hungarian Hung Old_Italic Ital Old_North_Arabian Narb Old_Permic Perm Old_Persian Xpeo Old_South_Arabian Sarb Old_Turkic Orkh Oriya Orya Osage Osge Osmanya Osma Pahawh_Hmong Hmng Palmyrene Palm Pau_Cin_Hau Pauc Phags_Pa Phag Phoenician Phnx Psalter_Pahlavi Phlp Rejang Rjng Runic Runr Samaritan Samr Saurashtra Saur Sharada Shrd Shavian Shaw Siddham Sidd SignWriting Sgnw Sinhala Sinh Sora_Sompeng Sora Soyombo Soyo Sundanese Sund Syloti_Nagri Sylo Syriac Syrc Tagalog Tglg Tagbanwa Tagb Tai_Le Tale Tai_Tham Lana Tai_Viet Tavt Takri Takr Tamil Taml Tangut Tang Telugu Telu Thaana Thaa Thai Thai Tibetan Tibt Tifinagh Tfng Tirhuta Tirh Ugaritic Ugar Vai Vaii Warang_Citi Wara Yi Yiii Zanabazar_Square Zanb", it = tt + " Dogra Dogr Gunjala_Gondi Gong Hanifi_Rohingya Rohg Makasar Maka Medefaidrin Medf Old_Sogdian Sogo Sogdian Sogd", st = it + " Elymaic Elym Nandinagari Nand Nyiakeng_Puachue_Hmong Hmnp Wancho Wcho", rt = st + " Chorasmian Chrs Diak Dives_Akuru Khitan_Small_Script Kits Yezi Yezidi", at = rt + " Cypro_Minoan Cpmn Old_Uyghur Ougr Tangsa Tnsa Toto Vithkuqi Vith", Mt = at + " " + Rt, Ut = {
  9: tt,
  10: it,
  11: st,
  12: rt,
  13: at,
  14: Mt
}, nt = {};
function jt(e) {
  var t = nt[e] = {
    binary: M(Bt[e] + " " + Ne),
    binaryOfStrings: M(Ft[e]),
    nonBinary: {
      General_Category: M(Ne),
      Script: M(Ut[e])
    }
  };
  t.nonBinary.Script_Extensions = t.nonBinary.Script, t.nonBinary.gc = t.nonBinary.General_Category, t.nonBinary.sc = t.nonBinary.Script, t.nonBinary.scx = t.nonBinary.Script_Extensions;
}
for (var xe = 0, Ve = [9, 10, 11, 12, 13, 14]; xe < Ve.length; xe += 1) {
  var qt = Ve[xe];
  jt(qt);
}
var c = _.prototype, ae = function(t, i) {
  this.parent = t, this.base = i || this;
};
ae.prototype.separatedFrom = function(t) {
  for (var i = this; i; i = i.parent)
    for (var s = t; s; s = s.parent)
      if (i.base === s.base && i !== s)
        return !0;
  return !1;
};
ae.prototype.sibling = function() {
  return new ae(this.parent, this.base);
};
var R = function(t) {
  this.parser = t, this.validFlags = "gim" + (t.options.ecmaVersion >= 6 ? "uy" : "") + (t.options.ecmaVersion >= 9 ? "s" : "") + (t.options.ecmaVersion >= 13 ? "d" : "") + (t.options.ecmaVersion >= 15 ? "v" : ""), this.unicodeProperties = nt[t.options.ecmaVersion >= 14 ? 14 : t.options.ecmaVersion], this.source = "", this.flags = "", this.start = 0, this.switchU = !1, this.switchV = !1, this.switchN = !1, this.pos = 0, this.lastIntValue = 0, this.lastStringValue = "", this.lastAssertionIsQuantifiable = !1, this.numCapturingParens = 0, this.maxBackReference = 0, this.groupNames = /* @__PURE__ */ Object.create(null), this.backReferenceNames = [], this.branchID = null;
};
R.prototype.reset = function(t, i, s) {
  var a = s.indexOf("v") !== -1, n = s.indexOf("u") !== -1;
  this.start = t | 0, this.source = i + "", this.flags = s, a && this.parser.options.ecmaVersion >= 15 ? (this.switchU = !0, this.switchV = !0, this.switchN = !0) : (this.switchU = n && this.parser.options.ecmaVersion >= 6, this.switchV = !1, this.switchN = n && this.parser.options.ecmaVersion >= 9);
};
R.prototype.raise = function(t) {
  this.parser.raiseRecoverable(this.start, "Invalid regular expression: /" + this.source + "/: " + t);
};
R.prototype.at = function(t, i) {
  i === void 0 && (i = !1);
  var s = this.source, a = s.length;
  if (t >= a)
    return -1;
  var n = s.charCodeAt(t);
  if (!(i || this.switchU) || n <= 55295 || n >= 57344 || t + 1 >= a)
    return n;
  var o = s.charCodeAt(t + 1);
  return o >= 56320 && o <= 57343 ? (n << 10) + o - 56613888 : n;
};
R.prototype.nextIndex = function(t, i) {
  i === void 0 && (i = !1);
  var s = this.source, a = s.length;
  if (t >= a)
    return a;
  var n = s.charCodeAt(t), o;
  return !(i || this.switchU) || n <= 55295 || n >= 57344 || t + 1 >= a || (o = s.charCodeAt(t + 1)) < 56320 || o > 57343 ? t + 1 : t + 2;
};
R.prototype.current = function(t) {
  return t === void 0 && (t = !1), this.at(this.pos, t);
};
R.prototype.lookahead = function(t) {
  return t === void 0 && (t = !1), this.at(this.nextIndex(this.pos, t), t);
};
R.prototype.advance = function(t) {
  t === void 0 && (t = !1), this.pos = this.nextIndex(this.pos, t);
};
R.prototype.eat = function(t, i) {
  return i === void 0 && (i = !1), this.current(i) === t ? (this.advance(i), !0) : !1;
};
R.prototype.eatChars = function(t, i) {
  i === void 0 && (i = !1);
  for (var s = this.pos, a = 0, n = t; a < n.length; a += 1) {
    var o = n[a], u = this.at(s, i);
    if (u === -1 || u !== o)
      return !1;
    s = this.nextIndex(s, i);
  }
  return this.pos = s, !0;
};
c.validateRegExpFlags = function(e) {
  for (var t = e.validFlags, i = e.flags, s = !1, a = !1, n = 0; n < i.length; n++) {
    var o = i.charAt(n);
    t.indexOf(o) === -1 && this.raise(e.start, "Invalid regular expression flag"), i.indexOf(o, n + 1) > -1 && this.raise(e.start, "Duplicate regular expression flag"), o === "u" && (s = !0), o === "v" && (a = !0);
  }
  this.options.ecmaVersion >= 15 && s && a && this.raise(e.start, "Invalid regular expression flag");
};
function Gt(e) {
  for (var t in e)
    return !0;
  return !1;
}
c.validateRegExpPattern = function(e) {
  this.regexp_pattern(e), !e.switchN && this.options.ecmaVersion >= 9 && Gt(e.groupNames) && (e.switchN = !0, this.regexp_pattern(e));
};
c.regexp_pattern = function(e) {
  e.pos = 0, e.lastIntValue = 0, e.lastStringValue = "", e.lastAssertionIsQuantifiable = !1, e.numCapturingParens = 0, e.maxBackReference = 0, e.groupNames = /* @__PURE__ */ Object.create(null), e.backReferenceNames.length = 0, e.branchID = null, this.regexp_disjunction(e), e.pos !== e.source.length && (e.eat(
    41
    /* ) */
  ) && e.raise("Unmatched ')'"), (e.eat(
    93
    /* ] */
  ) || e.eat(
    125
    /* } */
  )) && e.raise("Lone quantifier brackets")), e.maxBackReference > e.numCapturingParens && e.raise("Invalid escape");
  for (var t = 0, i = e.backReferenceNames; t < i.length; t += 1) {
    var s = i[t];
    e.groupNames[s] || e.raise("Invalid named capture referenced");
  }
};
c.regexp_disjunction = function(e) {
  var t = this.options.ecmaVersion >= 16;
  for (t && (e.branchID = new ae(e.branchID, null)), this.regexp_alternative(e); e.eat(
    124
    /* | */
  ); )
    t && (e.branchID = e.branchID.sibling()), this.regexp_alternative(e);
  t && (e.branchID = e.branchID.parent), this.regexp_eatQuantifier(e, !0) && e.raise("Nothing to repeat"), e.eat(
    123
    /* { */
  ) && e.raise("Lone quantifier brackets");
};
c.regexp_alternative = function(e) {
  for (; e.pos < e.source.length && this.regexp_eatTerm(e); )
    ;
};
c.regexp_eatTerm = function(e) {
  return this.regexp_eatAssertion(e) ? (e.lastAssertionIsQuantifiable && this.regexp_eatQuantifier(e) && e.switchU && e.raise("Invalid quantifier"), !0) : (e.switchU ? this.regexp_eatAtom(e) : this.regexp_eatExtendedAtom(e)) ? (this.regexp_eatQuantifier(e), !0) : !1;
};
c.regexp_eatAssertion = function(e) {
  var t = e.pos;
  if (e.lastAssertionIsQuantifiable = !1, e.eat(
    94
    /* ^ */
  ) || e.eat(
    36
    /* $ */
  ))
    return !0;
  if (e.eat(
    92
    /* \ */
  )) {
    if (e.eat(
      66
      /* B */
    ) || e.eat(
      98
      /* b */
    ))
      return !0;
    e.pos = t;
  }
  if (e.eat(
    40
    /* ( */
  ) && e.eat(
    63
    /* ? */
  )) {
    var i = !1;
    if (this.options.ecmaVersion >= 9 && (i = e.eat(
      60
      /* < */
    )), e.eat(
      61
      /* = */
    ) || e.eat(
      33
      /* ! */
    ))
      return this.regexp_disjunction(e), e.eat(
        41
        /* ) */
      ) || e.raise("Unterminated group"), e.lastAssertionIsQuantifiable = !i, !0;
  }
  return e.pos = t, !1;
};
c.regexp_eatQuantifier = function(e, t) {
  return t === void 0 && (t = !1), this.regexp_eatQuantifierPrefix(e, t) ? (e.eat(
    63
    /* ? */
  ), !0) : !1;
};
c.regexp_eatQuantifierPrefix = function(e, t) {
  return e.eat(
    42
    /* * */
  ) || e.eat(
    43
    /* + */
  ) || e.eat(
    63
    /* ? */
  ) || this.regexp_eatBracedQuantifier(e, t);
};
c.regexp_eatBracedQuantifier = function(e, t) {
  var i = e.pos;
  if (e.eat(
    123
    /* { */
  )) {
    var s = 0, a = -1;
    if (this.regexp_eatDecimalDigits(e) && (s = e.lastIntValue, e.eat(
      44
      /* , */
    ) && this.regexp_eatDecimalDigits(e) && (a = e.lastIntValue), e.eat(
      125
      /* } */
    )))
      return a !== -1 && a < s && !t && e.raise("numbers out of order in {} quantifier"), !0;
    e.switchU && !t && e.raise("Incomplete quantifier"), e.pos = i;
  }
  return !1;
};
c.regexp_eatAtom = function(e) {
  return this.regexp_eatPatternCharacters(e) || e.eat(
    46
    /* . */
  ) || this.regexp_eatReverseSolidusAtomEscape(e) || this.regexp_eatCharacterClass(e) || this.regexp_eatUncapturingGroup(e) || this.regexp_eatCapturingGroup(e);
};
c.regexp_eatReverseSolidusAtomEscape = function(e) {
  var t = e.pos;
  if (e.eat(
    92
    /* \ */
  )) {
    if (this.regexp_eatAtomEscape(e))
      return !0;
    e.pos = t;
  }
  return !1;
};
c.regexp_eatUncapturingGroup = function(e) {
  var t = e.pos;
  if (e.eat(
    40
    /* ( */
  )) {
    if (e.eat(
      63
      /* ? */
    )) {
      if (this.options.ecmaVersion >= 16) {
        var i = this.regexp_eatModifiers(e), s = e.eat(
          45
          /* - */
        );
        if (i || s) {
          for (var a = 0; a < i.length; a++) {
            var n = i.charAt(a);
            i.indexOf(n, a + 1) > -1 && e.raise("Duplicate regular expression modifiers");
          }
          if (s) {
            var o = this.regexp_eatModifiers(e);
            !i && !o && e.current() === 58 && e.raise("Invalid regular expression modifiers");
            for (var u = 0; u < o.length; u++) {
              var h = o.charAt(u);
              (o.indexOf(h, u + 1) > -1 || i.indexOf(h) > -1) && e.raise("Duplicate regular expression modifiers");
            }
          }
        }
      }
      if (e.eat(
        58
        /* : */
      )) {
        if (this.regexp_disjunction(e), e.eat(
          41
          /* ) */
        ))
          return !0;
        e.raise("Unterminated group");
      }
    }
    e.pos = t;
  }
  return !1;
};
c.regexp_eatCapturingGroup = function(e) {
  if (e.eat(
    40
    /* ( */
  )) {
    if (this.options.ecmaVersion >= 9 ? this.regexp_groupSpecifier(e) : e.current() === 63 && e.raise("Invalid group"), this.regexp_disjunction(e), e.eat(
      41
      /* ) */
    ))
      return e.numCapturingParens += 1, !0;
    e.raise("Unterminated group");
  }
  return !1;
};
c.regexp_eatModifiers = function(e) {
  for (var t = "", i = 0; (i = e.current()) !== -1 && Wt(i); )
    t += O(i), e.advance();
  return t;
};
function Wt(e) {
  return e === 105 || e === 109 || e === 115;
}
c.regexp_eatExtendedAtom = function(e) {
  return e.eat(
    46
    /* . */
  ) || this.regexp_eatReverseSolidusAtomEscape(e) || this.regexp_eatCharacterClass(e) || this.regexp_eatUncapturingGroup(e) || this.regexp_eatCapturingGroup(e) || this.regexp_eatInvalidBracedQuantifier(e) || this.regexp_eatExtendedPatternCharacter(e);
};
c.regexp_eatInvalidBracedQuantifier = function(e) {
  return this.regexp_eatBracedQuantifier(e, !0) && e.raise("Nothing to repeat"), !1;
};
c.regexp_eatSyntaxCharacter = function(e) {
  var t = e.current();
  return ot(t) ? (e.lastIntValue = t, e.advance(), !0) : !1;
};
function ot(e) {
  return e === 36 || e >= 40 && e <= 43 || e === 46 || e === 63 || e >= 91 && e <= 94 || e >= 123 && e <= 125;
}
c.regexp_eatPatternCharacters = function(e) {
  for (var t = e.pos, i = 0; (i = e.current()) !== -1 && !ot(i); )
    e.advance();
  return e.pos !== t;
};
c.regexp_eatExtendedPatternCharacter = function(e) {
  var t = e.current();
  return t !== -1 && t !== 36 && !(t >= 40 && t <= 43) && t !== 46 && t !== 63 && t !== 91 && t !== 94 && t !== 124 ? (e.advance(), !0) : !1;
};
c.regexp_groupSpecifier = function(e) {
  if (e.eat(
    63
    /* ? */
  )) {
    this.regexp_eatGroupName(e) || e.raise("Invalid group");
    var t = this.options.ecmaVersion >= 16, i = e.groupNames[e.lastStringValue];
    if (i)
      if (t)
        for (var s = 0, a = i; s < a.length; s += 1) {
          var n = a[s];
          n.separatedFrom(e.branchID) || e.raise("Duplicate capture group name");
        }
      else
        e.raise("Duplicate capture group name");
    t ? (i || (e.groupNames[e.lastStringValue] = [])).push(e.branchID) : e.groupNames[e.lastStringValue] = !0;
  }
};
c.regexp_eatGroupName = function(e) {
  if (e.lastStringValue = "", e.eat(
    60
    /* < */
  )) {
    if (this.regexp_eatRegExpIdentifierName(e) && e.eat(
      62
      /* > */
    ))
      return !0;
    e.raise("Invalid capture group name");
  }
  return !1;
};
c.regexp_eatRegExpIdentifierName = function(e) {
  if (e.lastStringValue = "", this.regexp_eatRegExpIdentifierStart(e)) {
    for (e.lastStringValue += O(e.lastIntValue); this.regexp_eatRegExpIdentifierPart(e); )
      e.lastStringValue += O(e.lastIntValue);
    return !0;
  }
  return !1;
};
c.regexp_eatRegExpIdentifierStart = function(e) {
  var t = e.pos, i = this.options.ecmaVersion >= 11, s = e.current(i);
  return e.advance(i), s === 92 && this.regexp_eatRegExpUnicodeEscapeSequence(e, i) && (s = e.lastIntValue), Ht(s) ? (e.lastIntValue = s, !0) : (e.pos = t, !1);
};
function Ht(e) {
  return L(e, !0) || e === 36 || e === 95;
}
c.regexp_eatRegExpIdentifierPart = function(e) {
  var t = e.pos, i = this.options.ecmaVersion >= 11, s = e.current(i);
  return e.advance(i), s === 92 && this.regexp_eatRegExpUnicodeEscapeSequence(e, i) && (s = e.lastIntValue), zt(s) ? (e.lastIntValue = s, !0) : (e.pos = t, !1);
};
function zt(e) {
  return U(e, !0) || e === 36 || e === 95 || e === 8204 || e === 8205;
}
c.regexp_eatAtomEscape = function(e) {
  return this.regexp_eatBackReference(e) || this.regexp_eatCharacterClassEscape(e) || this.regexp_eatCharacterEscape(e) || e.switchN && this.regexp_eatKGroupName(e) ? !0 : (e.switchU && (e.current() === 99 && e.raise("Invalid unicode escape"), e.raise("Invalid escape")), !1);
};
c.regexp_eatBackReference = function(e) {
  var t = e.pos;
  if (this.regexp_eatDecimalEscape(e)) {
    var i = e.lastIntValue;
    if (e.switchU)
      return i > e.maxBackReference && (e.maxBackReference = i), !0;
    if (i <= e.numCapturingParens)
      return !0;
    e.pos = t;
  }
  return !1;
};
c.regexp_eatKGroupName = function(e) {
  if (e.eat(
    107
    /* k */
  )) {
    if (this.regexp_eatGroupName(e))
      return e.backReferenceNames.push(e.lastStringValue), !0;
    e.raise("Invalid named reference");
  }
  return !1;
};
c.regexp_eatCharacterEscape = function(e) {
  return this.regexp_eatControlEscape(e) || this.regexp_eatCControlLetter(e) || this.regexp_eatZero(e) || this.regexp_eatHexEscapeSequence(e) || this.regexp_eatRegExpUnicodeEscapeSequence(e, !1) || !e.switchU && this.regexp_eatLegacyOctalEscapeSequence(e) || this.regexp_eatIdentityEscape(e);
};
c.regexp_eatCControlLetter = function(e) {
  var t = e.pos;
  if (e.eat(
    99
    /* c */
  )) {
    if (this.regexp_eatControlLetter(e))
      return !0;
    e.pos = t;
  }
  return !1;
};
c.regexp_eatZero = function(e) {
  return e.current() === 48 && !le(e.lookahead()) ? (e.lastIntValue = 0, e.advance(), !0) : !1;
};
c.regexp_eatControlEscape = function(e) {
  var t = e.current();
  return t === 116 ? (e.lastIntValue = 9, e.advance(), !0) : t === 110 ? (e.lastIntValue = 10, e.advance(), !0) : t === 118 ? (e.lastIntValue = 11, e.advance(), !0) : t === 102 ? (e.lastIntValue = 12, e.advance(), !0) : t === 114 ? (e.lastIntValue = 13, e.advance(), !0) : !1;
};
c.regexp_eatControlLetter = function(e) {
  var t = e.current();
  return ut(t) ? (e.lastIntValue = t % 32, e.advance(), !0) : !1;
};
function ut(e) {
  return e >= 65 && e <= 90 || e >= 97 && e <= 122;
}
c.regexp_eatRegExpUnicodeEscapeSequence = function(e, t) {
  t === void 0 && (t = !1);
  var i = e.pos, s = t || e.switchU;
  if (e.eat(
    117
    /* u */
  )) {
    if (this.regexp_eatFixedHexDigits(e, 4)) {
      var a = e.lastIntValue;
      if (s && a >= 55296 && a <= 56319) {
        var n = e.pos;
        if (e.eat(
          92
          /* \ */
        ) && e.eat(
          117
          /* u */
        ) && this.regexp_eatFixedHexDigits(e, 4)) {
          var o = e.lastIntValue;
          if (o >= 56320 && o <= 57343)
            return e.lastIntValue = (a - 55296) * 1024 + (o - 56320) + 65536, !0;
        }
        e.pos = n, e.lastIntValue = a;
      }
      return !0;
    }
    if (s && e.eat(
      123
      /* { */
    ) && this.regexp_eatHexDigits(e) && e.eat(
      125
      /* } */
    ) && Kt(e.lastIntValue))
      return !0;
    s && e.raise("Invalid unicode escape"), e.pos = i;
  }
  return !1;
};
function Kt(e) {
  return e >= 0 && e <= 1114111;
}
c.regexp_eatIdentityEscape = function(e) {
  if (e.switchU)
    return this.regexp_eatSyntaxCharacter(e) ? !0 : e.eat(
      47
      /* / */
    ) ? (e.lastIntValue = 47, !0) : !1;
  var t = e.current();
  return t !== 99 && (!e.switchN || t !== 107) ? (e.lastIntValue = t, e.advance(), !0) : !1;
};
c.regexp_eatDecimalEscape = function(e) {
  e.lastIntValue = 0;
  var t = e.current();
  if (t >= 49 && t <= 57) {
    do
      e.lastIntValue = 10 * e.lastIntValue + (t - 48), e.advance();
    while ((t = e.current()) >= 48 && t <= 57);
    return !0;
  }
  return !1;
};
var ht = 0, B = 1, P = 2;
c.regexp_eatCharacterClassEscape = function(e) {
  var t = e.current();
  if (Qt(t))
    return e.lastIntValue = -1, e.advance(), B;
  var i = !1;
  if (e.switchU && this.options.ecmaVersion >= 9 && ((i = t === 80) || t === 112)) {
    e.lastIntValue = -1, e.advance();
    var s;
    if (e.eat(
      123
      /* { */
    ) && (s = this.regexp_eatUnicodePropertyValueExpression(e)) && e.eat(
      125
      /* } */
    ))
      return i && s === P && e.raise("Invalid property name"), s;
    e.raise("Invalid property name");
  }
  return ht;
};
function Qt(e) {
  return e === 100 || e === 68 || e === 115 || e === 83 || e === 119 || e === 87;
}
c.regexp_eatUnicodePropertyValueExpression = function(e) {
  var t = e.pos;
  if (this.regexp_eatUnicodePropertyName(e) && e.eat(
    61
    /* = */
  )) {
    var i = e.lastStringValue;
    if (this.regexp_eatUnicodePropertyValue(e)) {
      var s = e.lastStringValue;
      return this.regexp_validateUnicodePropertyNameAndValue(e, i, s), B;
    }
  }
  if (e.pos = t, this.regexp_eatLoneUnicodePropertyNameOrValue(e)) {
    var a = e.lastStringValue;
    return this.regexp_validateUnicodePropertyNameOrValue(e, a);
  }
  return ht;
};
c.regexp_validateUnicodePropertyNameAndValue = function(e, t, i) {
  Q(e.unicodeProperties.nonBinary, t) || e.raise("Invalid property name"), e.unicodeProperties.nonBinary[t].test(i) || e.raise("Invalid property value");
};
c.regexp_validateUnicodePropertyNameOrValue = function(e, t) {
  if (e.unicodeProperties.binary.test(t))
    return B;
  if (e.switchV && e.unicodeProperties.binaryOfStrings.test(t))
    return P;
  e.raise("Invalid property name");
};
c.regexp_eatUnicodePropertyName = function(e) {
  var t = 0;
  for (e.lastStringValue = ""; ct(t = e.current()); )
    e.lastStringValue += O(t), e.advance();
  return e.lastStringValue !== "";
};
function ct(e) {
  return ut(e) || e === 95;
}
c.regexp_eatUnicodePropertyValue = function(e) {
  var t = 0;
  for (e.lastStringValue = ""; Yt(t = e.current()); )
    e.lastStringValue += O(t), e.advance();
  return e.lastStringValue !== "";
};
function Yt(e) {
  return ct(e) || le(e);
}
c.regexp_eatLoneUnicodePropertyNameOrValue = function(e) {
  return this.regexp_eatUnicodePropertyValue(e);
};
c.regexp_eatCharacterClass = function(e) {
  if (e.eat(
    91
    /* [ */
  )) {
    var t = e.eat(
      94
      /* ^ */
    ), i = this.regexp_classContents(e);
    return e.eat(
      93
      /* ] */
    ) || e.raise("Unterminated character class"), t && i === P && e.raise("Negated character class may contain strings"), !0;
  }
  return !1;
};
c.regexp_classContents = function(e) {
  return e.current() === 93 ? B : e.switchV ? this.regexp_classSetExpression(e) : (this.regexp_nonEmptyClassRanges(e), B);
};
c.regexp_nonEmptyClassRanges = function(e) {
  for (; this.regexp_eatClassAtom(e); ) {
    var t = e.lastIntValue;
    if (e.eat(
      45
      /* - */
    ) && this.regexp_eatClassAtom(e)) {
      var i = e.lastIntValue;
      e.switchU && (t === -1 || i === -1) && e.raise("Invalid character class"), t !== -1 && i !== -1 && t > i && e.raise("Range out of order in character class");
    }
  }
};
c.regexp_eatClassAtom = function(e) {
  var t = e.pos;
  if (e.eat(
    92
    /* \ */
  )) {
    if (this.regexp_eatClassEscape(e))
      return !0;
    if (e.switchU) {
      var i = e.current();
      (i === 99 || ft(i)) && e.raise("Invalid class escape"), e.raise("Invalid escape");
    }
    e.pos = t;
  }
  var s = e.current();
  return s !== 93 ? (e.lastIntValue = s, e.advance(), !0) : !1;
};
c.regexp_eatClassEscape = function(e) {
  var t = e.pos;
  if (e.eat(
    98
    /* b */
  ))
    return e.lastIntValue = 8, !0;
  if (e.switchU && e.eat(
    45
    /* - */
  ))
    return e.lastIntValue = 45, !0;
  if (!e.switchU && e.eat(
    99
    /* c */
  )) {
    if (this.regexp_eatClassControlLetter(e))
      return !0;
    e.pos = t;
  }
  return this.regexp_eatCharacterClassEscape(e) || this.regexp_eatCharacterEscape(e);
};
c.regexp_classSetExpression = function(e) {
  var t = B, i;
  if (!this.regexp_eatClassSetRange(e)) if (i = this.regexp_eatClassSetOperand(e)) {
    i === P && (t = P);
    for (var s = e.pos; e.eatChars(
      [38, 38]
      /* && */
    ); ) {
      if (e.current() !== 38 && (i = this.regexp_eatClassSetOperand(e))) {
        i !== P && (t = B);
        continue;
      }
      e.raise("Invalid character in character class");
    }
    if (s !== e.pos)
      return t;
    for (; e.eatChars(
      [45, 45]
      /* -- */
    ); )
      this.regexp_eatClassSetOperand(e) || e.raise("Invalid character in character class");
    if (s !== e.pos)
      return t;
  } else
    e.raise("Invalid character in character class");
  for (; ; )
    if (!this.regexp_eatClassSetRange(e)) {
      if (i = this.regexp_eatClassSetOperand(e), !i)
        return t;
      i === P && (t = P);
    }
};
c.regexp_eatClassSetRange = function(e) {
  var t = e.pos;
  if (this.regexp_eatClassSetCharacter(e)) {
    var i = e.lastIntValue;
    if (e.eat(
      45
      /* - */
    ) && this.regexp_eatClassSetCharacter(e)) {
      var s = e.lastIntValue;
      return i !== -1 && s !== -1 && i > s && e.raise("Range out of order in character class"), !0;
    }
    e.pos = t;
  }
  return !1;
};
c.regexp_eatClassSetOperand = function(e) {
  return this.regexp_eatClassSetCharacter(e) ? B : this.regexp_eatClassStringDisjunction(e) || this.regexp_eatNestedClass(e);
};
c.regexp_eatNestedClass = function(e) {
  var t = e.pos;
  if (e.eat(
    91
    /* [ */
  )) {
    var i = e.eat(
      94
      /* ^ */
    ), s = this.regexp_classContents(e);
    if (e.eat(
      93
      /* ] */
    ))
      return i && s === P && e.raise("Negated character class may contain strings"), s;
    e.pos = t;
  }
  if (e.eat(
    92
    /* \ */
  )) {
    var a = this.regexp_eatCharacterClassEscape(e);
    if (a)
      return a;
    e.pos = t;
  }
  return null;
};
c.regexp_eatClassStringDisjunction = function(e) {
  var t = e.pos;
  if (e.eatChars(
    [92, 113]
    /* \q */
  )) {
    if (e.eat(
      123
      /* { */
    )) {
      var i = this.regexp_classStringDisjunctionContents(e);
      if (e.eat(
        125
        /* } */
      ))
        return i;
    } else
      e.raise("Invalid escape");
    e.pos = t;
  }
  return null;
};
c.regexp_classStringDisjunctionContents = function(e) {
  for (var t = this.regexp_classString(e); e.eat(
    124
    /* | */
  ); )
    this.regexp_classString(e) === P && (t = P);
  return t;
};
c.regexp_classString = function(e) {
  for (var t = 0; this.regexp_eatClassSetCharacter(e); )
    t++;
  return t === 1 ? B : P;
};
c.regexp_eatClassSetCharacter = function(e) {
  var t = e.pos;
  if (e.eat(
    92
    /* \ */
  ))
    return this.regexp_eatCharacterEscape(e) || this.regexp_eatClassSetReservedPunctuator(e) ? !0 : e.eat(
      98
      /* b */
    ) ? (e.lastIntValue = 8, !0) : (e.pos = t, !1);
  var i = e.current();
  return i < 0 || i === e.lookahead() && Xt(i) || Zt(i) ? !1 : (e.advance(), e.lastIntValue = i, !0);
};
function Xt(e) {
  return e === 33 || e >= 35 && e <= 38 || e >= 42 && e <= 44 || e === 46 || e >= 58 && e <= 64 || e === 94 || e === 96 || e === 126;
}
function Zt(e) {
  return e === 40 || e === 41 || e === 45 || e === 47 || e >= 91 && e <= 93 || e >= 123 && e <= 125;
}
c.regexp_eatClassSetReservedPunctuator = function(e) {
  var t = e.current();
  return Jt(t) ? (e.lastIntValue = t, e.advance(), !0) : !1;
};
function Jt(e) {
  return e === 33 || e === 35 || e === 37 || e === 38 || e === 44 || e === 45 || e >= 58 && e <= 62 || e === 64 || e === 96 || e === 126;
}
c.regexp_eatClassControlLetter = function(e) {
  var t = e.current();
  return le(t) || t === 95 ? (e.lastIntValue = t % 32, e.advance(), !0) : !1;
};
c.regexp_eatHexEscapeSequence = function(e) {
  var t = e.pos;
  if (e.eat(
    120
    /* x */
  )) {
    if (this.regexp_eatFixedHexDigits(e, 2))
      return !0;
    e.switchU && e.raise("Invalid escape"), e.pos = t;
  }
  return !1;
};
c.regexp_eatDecimalDigits = function(e) {
  var t = e.pos, i = 0;
  for (e.lastIntValue = 0; le(i = e.current()); )
    e.lastIntValue = 10 * e.lastIntValue + (i - 48), e.advance();
  return e.pos !== t;
};
function le(e) {
  return e >= 48 && e <= 57;
}
c.regexp_eatHexDigits = function(e) {
  var t = e.pos, i = 0;
  for (e.lastIntValue = 0; lt(i = e.current()); )
    e.lastIntValue = 16 * e.lastIntValue + pt(i), e.advance();
  return e.pos !== t;
};
function lt(e) {
  return e >= 48 && e <= 57 || e >= 65 && e <= 70 || e >= 97 && e <= 102;
}
function pt(e) {
  return e >= 65 && e <= 70 ? 10 + (e - 65) : e >= 97 && e <= 102 ? 10 + (e - 97) : e - 48;
}
c.regexp_eatLegacyOctalEscapeSequence = function(e) {
  if (this.regexp_eatOctalDigit(e)) {
    var t = e.lastIntValue;
    if (this.regexp_eatOctalDigit(e)) {
      var i = e.lastIntValue;
      t <= 3 && this.regexp_eatOctalDigit(e) ? e.lastIntValue = t * 64 + i * 8 + e.lastIntValue : e.lastIntValue = t * 8 + i;
    } else
      e.lastIntValue = t;
    return !0;
  }
  return !1;
};
c.regexp_eatOctalDigit = function(e) {
  var t = e.current();
  return ft(t) ? (e.lastIntValue = t - 48, e.advance(), !0) : (e.lastIntValue = 0, !1);
};
function ft(e) {
  return e >= 48 && e <= 55;
}
c.regexp_eatFixedHexDigits = function(e, t) {
  var i = e.pos;
  e.lastIntValue = 0;
  for (var s = 0; s < t; ++s) {
    var a = e.current();
    if (!lt(a))
      return e.pos = i, !1;
    e.lastIntValue = 16 * e.lastIntValue + pt(a), e.advance();
  }
  return !0;
};
var Ee = function(t) {
  this.type = t.type, this.value = t.value, this.start = t.start, this.end = t.end, t.options.locations && (this.loc = new ne(t, t.startLoc, t.endLoc)), t.options.ranges && (this.range = [t.start, t.end]);
}, m = _.prototype;
m.next = function(e) {
  !e && this.type.keyword && this.containsEsc && this.raiseRecoverable(this.start, "Escape sequence in keyword " + this.type.keyword), this.options.onToken && this.options.onToken(new Ee(this)), this.lastTokEnd = this.end, this.lastTokStart = this.start, this.lastTokEndLoc = this.endLoc, this.lastTokStartLoc = this.startLoc, this.nextToken();
};
m.getToken = function() {
  return this.next(), new Ee(this);
};
typeof Symbol < "u" && (m[Symbol.iterator] = function() {
  var e = this;
  return {
    next: function() {
      var t = e.getToken();
      return {
        done: t.type === r.eof,
        value: t
      };
    }
  };
});
m.nextToken = function() {
  var e = this.curContext();
  if ((!e || !e.preserveSpace) && this.skipSpace(), this.start = this.pos, this.options.locations && (this.startLoc = this.curPosition()), this.pos >= this.input.length)
    return this.finishToken(r.eof);
  if (e.override)
    return e.override(this);
  this.readToken(this.fullCharCodeAtPos());
};
m.readToken = function(e) {
  return L(e, this.options.ecmaVersion >= 6) || e === 92 ? this.readWord() : this.getTokenFromCode(e);
};
m.fullCharCodeAt = function(e) {
  var t = this.input.charCodeAt(e);
  if (t <= 55295 || t >= 56320)
    return t;
  var i = this.input.charCodeAt(e + 1);
  return i <= 56319 || i >= 57344 ? t : (t << 10) + i - 56613888;
};
m.fullCharCodeAtPos = function() {
  return this.fullCharCodeAt(this.pos);
};
m.skipBlockComment = function() {
  var e = this.options.onComment && this.curPosition(), t = this.pos, i = this.input.indexOf("*/", this.pos += 2);
  if (i === -1 && this.raise(this.pos - 2, "Unterminated comment"), this.pos = i + 2, this.options.locations)
    for (var s = void 0, a = t; (s = Be(this.input, a, this.pos)) > -1; )
      ++this.curLine, a = this.lineStart = s;
  this.options.onComment && this.options.onComment(
    !0,
    this.input.slice(t + 2, i),
    t,
    this.pos,
    e,
    this.curPosition()
  );
};
m.skipLineComment = function(e) {
  for (var t = this.pos, i = this.options.onComment && this.curPosition(), s = this.input.charCodeAt(this.pos += e); this.pos < this.input.length && !K(s); )
    s = this.input.charCodeAt(++this.pos);
  this.options.onComment && this.options.onComment(
    !1,
    this.input.slice(t + e, this.pos),
    t,
    this.pos,
    i,
    this.curPosition()
  );
};
m.skipSpace = function() {
  e: for (; this.pos < this.input.length; ) {
    var e = this.input.charCodeAt(this.pos);
    switch (e) {
      case 32:
      case 160:
        ++this.pos;
        break;
      case 13:
        this.input.charCodeAt(this.pos + 1) === 10 && ++this.pos;
      case 10:
      case 8232:
      case 8233:
        ++this.pos, this.options.locations && (++this.curLine, this.lineStart = this.pos);
        break;
      case 47:
        switch (this.input.charCodeAt(this.pos + 1)) {
          case 42:
            this.skipBlockComment();
            break;
          case 47:
            this.skipLineComment(2);
            break;
          default:
            break e;
        }
        break;
      default:
        if (e > 8 && e < 14 || e >= 5760 && De.test(String.fromCharCode(e)))
          ++this.pos;
        else
          break e;
    }
  }
};
m.finishToken = function(e, t) {
  this.end = this.pos, this.options.locations && (this.endLoc = this.curPosition());
  var i = this.type;
  this.type = e, this.value = t, this.updateContext(i);
};
m.readToken_dot = function() {
  var e = this.input.charCodeAt(this.pos + 1);
  if (e >= 48 && e <= 57)
    return this.readNumber(!0);
  var t = this.input.charCodeAt(this.pos + 2);
  return this.options.ecmaVersion >= 6 && e === 46 && t === 46 ? (this.pos += 3, this.finishToken(r.ellipsis)) : (++this.pos, this.finishToken(r.dot));
};
m.readToken_slash = function() {
  var e = this.input.charCodeAt(this.pos + 1);
  return this.exprAllowed ? (++this.pos, this.readRegexp()) : e === 61 ? this.finishOp(r.assign, 2) : this.finishOp(r.slash, 1);
};
m.readToken_mult_modulo_exp = function(e) {
  var t = this.input.charCodeAt(this.pos + 1), i = 1, s = e === 42 ? r.star : r.modulo;
  return this.options.ecmaVersion >= 7 && e === 42 && t === 42 && (++i, s = r.starstar, t = this.input.charCodeAt(this.pos + 2)), t === 61 ? this.finishOp(r.assign, i + 1) : this.finishOp(s, i);
};
m.readToken_pipe_amp = function(e) {
  var t = this.input.charCodeAt(this.pos + 1);
  if (t === e) {
    if (this.options.ecmaVersion >= 12) {
      var i = this.input.charCodeAt(this.pos + 2);
      if (i === 61)
        return this.finishOp(r.assign, 3);
    }
    return this.finishOp(e === 124 ? r.logicalOR : r.logicalAND, 2);
  }
  return t === 61 ? this.finishOp(r.assign, 2) : this.finishOp(e === 124 ? r.bitwiseOR : r.bitwiseAND, 1);
};
m.readToken_caret = function() {
  var e = this.input.charCodeAt(this.pos + 1);
  return e === 61 ? this.finishOp(r.assign, 2) : this.finishOp(r.bitwiseXOR, 1);
};
m.readToken_plus_min = function(e) {
  var t = this.input.charCodeAt(this.pos + 1);
  return t === e ? t === 45 && !this.inModule && this.input.charCodeAt(this.pos + 2) === 62 && (this.lastTokEnd === 0 || w.test(this.input.slice(this.lastTokEnd, this.pos))) ? (this.skipLineComment(3), this.skipSpace(), this.nextToken()) : this.finishOp(r.incDec, 2) : t === 61 ? this.finishOp(r.assign, 2) : this.finishOp(r.plusMin, 1);
};
m.readToken_lt_gt = function(e) {
  var t = this.input.charCodeAt(this.pos + 1), i = 1;
  return t === e ? (i = e === 62 && this.input.charCodeAt(this.pos + 2) === 62 ? 3 : 2, this.input.charCodeAt(this.pos + i) === 61 ? this.finishOp(r.assign, i + 1) : this.finishOp(r.bitShift, i)) : t === 33 && e === 60 && !this.inModule && this.input.charCodeAt(this.pos + 2) === 45 && this.input.charCodeAt(this.pos + 3) === 45 ? (this.skipLineComment(4), this.skipSpace(), this.nextToken()) : (t === 61 && (i = 2), this.finishOp(r.relational, i));
};
m.readToken_eq_excl = function(e) {
  var t = this.input.charCodeAt(this.pos + 1);
  return t === 61 ? this.finishOp(r.equality, this.input.charCodeAt(this.pos + 2) === 61 ? 3 : 2) : e === 61 && t === 62 && this.options.ecmaVersion >= 6 ? (this.pos += 2, this.finishToken(r.arrow)) : this.finishOp(e === 61 ? r.eq : r.prefix, 1);
};
m.readToken_question = function() {
  var e = this.options.ecmaVersion;
  if (e >= 11) {
    var t = this.input.charCodeAt(this.pos + 1);
    if (t === 46) {
      var i = this.input.charCodeAt(this.pos + 2);
      if (i < 48 || i > 57)
        return this.finishOp(r.questionDot, 2);
    }
    if (t === 63) {
      if (e >= 12) {
        var s = this.input.charCodeAt(this.pos + 2);
        if (s === 61)
          return this.finishOp(r.assign, 3);
      }
      return this.finishOp(r.coalesce, 2);
    }
  }
  return this.finishOp(r.question, 1);
};
m.readToken_numberSign = function() {
  var e = this.options.ecmaVersion, t = 35;
  if (e >= 13 && (++this.pos, t = this.fullCharCodeAtPos(), L(t, !0) || t === 92))
    return this.finishToken(r.privateId, this.readWord1());
  this.raise(this.pos, "Unexpected character '" + O(t) + "'");
};
m.getTokenFromCode = function(e) {
  switch (e) {
    // The interpretation of a dot depends on whether it is followed
    // by a digit or another two dots.
    case 46:
      return this.readToken_dot();
    // Punctuation tokens.
    case 40:
      return ++this.pos, this.finishToken(r.parenL);
    case 41:
      return ++this.pos, this.finishToken(r.parenR);
    case 59:
      return ++this.pos, this.finishToken(r.semi);
    case 44:
      return ++this.pos, this.finishToken(r.comma);
    case 91:
      return ++this.pos, this.finishToken(r.bracketL);
    case 93:
      return ++this.pos, this.finishToken(r.bracketR);
    case 123:
      return ++this.pos, this.finishToken(r.braceL);
    case 125:
      return ++this.pos, this.finishToken(r.braceR);
    case 58:
      return ++this.pos, this.finishToken(r.colon);
    case 96:
      if (this.options.ecmaVersion < 6)
        break;
      return ++this.pos, this.finishToken(r.backQuote);
    case 48:
      var t = this.input.charCodeAt(this.pos + 1);
      if (t === 120 || t === 88)
        return this.readRadixNumber(16);
      if (this.options.ecmaVersion >= 6) {
        if (t === 111 || t === 79)
          return this.readRadixNumber(8);
        if (t === 98 || t === 66)
          return this.readRadixNumber(2);
      }
    // Anything else beginning with a digit is an integer, octal
    // number, or float.
    case 49:
    case 50:
    case 51:
    case 52:
    case 53:
    case 54:
    case 55:
    case 56:
    case 57:
      return this.readNumber(!1);
    // Quotes produce strings.
    case 34:
    case 39:
      return this.readString(e);
    // Operators are parsed inline in tiny state machines. '=' (61) is
    // often referred to. `finishOp` simply skips the amount of
    // characters it is given as second argument, and returns a token
    // of the type given by its first argument.
    case 47:
      return this.readToken_slash();
    case 37:
    case 42:
      return this.readToken_mult_modulo_exp(e);
    case 124:
    case 38:
      return this.readToken_pipe_amp(e);
    case 94:
      return this.readToken_caret();
    case 43:
    case 45:
      return this.readToken_plus_min(e);
    case 60:
    case 62:
      return this.readToken_lt_gt(e);
    case 61:
    case 33:
      return this.readToken_eq_excl(e);
    case 63:
      return this.readToken_question();
    case 126:
      return this.finishOp(r.prefix, 1);
    case 35:
      return this.readToken_numberSign();
  }
  this.raise(this.pos, "Unexpected character '" + O(e) + "'");
};
m.finishOp = function(e, t) {
  var i = this.input.slice(this.pos, this.pos + t);
  return this.pos += t, this.finishToken(e, i);
};
m.readRegexp = function() {
  for (var e, t, i = this.pos; ; ) {
    this.pos >= this.input.length && this.raise(i, "Unterminated regular expression");
    var s = this.input.charAt(this.pos);
    if (w.test(s) && this.raise(i, "Unterminated regular expression"), e)
      e = !1;
    else {
      if (s === "[")
        t = !0;
      else if (s === "]" && t)
        t = !1;
      else if (s === "/" && !t)
        break;
      e = s === "\\";
    }
    ++this.pos;
  }
  var a = this.input.slice(i, this.pos);
  ++this.pos;
  var n = this.pos, o = this.readWord1();
  this.containsEsc && this.unexpected(n);
  var u = this.regexpState || (this.regexpState = new R(this));
  u.reset(i, a, o), this.validateRegExpFlags(u), this.validateRegExpPattern(u);
  var h = null;
  try {
    h = new RegExp(a, o);
  } catch {
  }
  return this.finishToken(r.regexp, { pattern: a, flags: o, value: h });
};
m.readInt = function(e, t, i) {
  for (var s = this.options.ecmaVersion >= 12 && t === void 0, a = i && this.input.charCodeAt(this.pos) === 48, n = this.pos, o = 0, u = 0, h = 0, p = t ?? 1 / 0; h < p; ++h, ++this.pos) {
    var d = this.input.charCodeAt(this.pos), b = void 0;
    if (s && d === 95) {
      a && this.raiseRecoverable(this.pos, "Numeric separator is not allowed in legacy octal numeric literals"), u === 95 && this.raiseRecoverable(this.pos, "Numeric separator must be exactly one underscore"), h === 0 && this.raiseRecoverable(this.pos, "Numeric separator is not allowed at the first of digits"), u = d;
      continue;
    }
    if (d >= 97 ? b = d - 97 + 10 : d >= 65 ? b = d - 65 + 10 : d >= 48 && d <= 57 ? b = d - 48 : b = 1 / 0, b >= e)
      break;
    u = d, o = o * e + b;
  }
  return s && u === 95 && this.raiseRecoverable(this.pos - 1, "Numeric separator is not allowed at the last of digits"), this.pos === n || t != null && this.pos - n !== t ? null : o;
};
function $t(e, t) {
  return t ? parseInt(e, 8) : parseFloat(e.replace(/_/g, ""));
}
function dt(e) {
  return typeof BigInt != "function" ? null : BigInt(e.replace(/_/g, ""));
}
m.readRadixNumber = function(e) {
  var t = this.pos;
  this.pos += 2;
  var i = this.readInt(e);
  return i == null && this.raise(this.start + 2, "Expected number in radix " + e), this.options.ecmaVersion >= 11 && this.input.charCodeAt(this.pos) === 110 ? (i = dt(this.input.slice(t, this.pos)), ++this.pos) : L(this.fullCharCodeAtPos()) && this.raise(this.pos, "Identifier directly after number"), this.finishToken(r.num, i);
};
m.readNumber = function(e) {
  var t = this.pos;
  !e && this.readInt(10, void 0, !0) === null && this.raise(t, "Invalid number");
  var i = this.pos - t >= 2 && this.input.charCodeAt(t) === 48;
  i && this.strict && this.raise(t, "Invalid number");
  var s = this.input.charCodeAt(this.pos);
  if (!i && !e && this.options.ecmaVersion >= 11 && s === 110) {
    var a = dt(this.input.slice(t, this.pos));
    return ++this.pos, L(this.fullCharCodeAtPos()) && this.raise(this.pos, "Identifier directly after number"), this.finishToken(r.num, a);
  }
  i && /[89]/.test(this.input.slice(t, this.pos)) && (i = !1), s === 46 && !i && (++this.pos, this.readInt(10), s = this.input.charCodeAt(this.pos)), (s === 69 || s === 101) && !i && (s = this.input.charCodeAt(++this.pos), (s === 43 || s === 45) && ++this.pos, this.readInt(10) === null && this.raise(t, "Invalid number")), L(this.fullCharCodeAtPos()) && this.raise(this.pos, "Identifier directly after number");
  var n = $t(this.input.slice(t, this.pos), i);
  return this.finishToken(r.num, n);
};
m.readCodePoint = function() {
  var e = this.input.charCodeAt(this.pos), t;
  if (e === 123) {
    this.options.ecmaVersion < 6 && this.unexpected();
    var i = ++this.pos;
    t = this.readHexChar(this.input.indexOf("}", this.pos) - this.pos), ++this.pos, t > 1114111 && this.invalidStringToken(i, "Code point out of bounds");
  } else
    t = this.readHexChar(4);
  return t;
};
m.readString = function(e) {
  for (var t = "", i = ++this.pos; ; ) {
    this.pos >= this.input.length && this.raise(this.start, "Unterminated string constant");
    var s = this.input.charCodeAt(this.pos);
    if (s === e)
      break;
    s === 92 ? (t += this.input.slice(i, this.pos), t += this.readEscapedChar(!1), i = this.pos) : s === 8232 || s === 8233 ? (this.options.ecmaVersion < 10 && this.raise(this.start, "Unterminated string constant"), ++this.pos, this.options.locations && (this.curLine++, this.lineStart = this.pos)) : (K(s) && this.raise(this.start, "Unterminated string constant"), ++this.pos);
  }
  return t += this.input.slice(i, this.pos++), this.finishToken(r.string, t);
};
var xt = {};
m.tryReadTemplateToken = function() {
  this.inTemplateElement = !0;
  try {
    this.readTmplToken();
  } catch (e) {
    if (e === xt)
      this.readInvalidTemplateToken();
    else
      throw e;
  }
  this.inTemplateElement = !1;
};
m.invalidStringToken = function(e, t) {
  if (this.inTemplateElement && this.options.ecmaVersion >= 9)
    throw xt;
  this.raise(e, t);
};
m.readTmplToken = function() {
  for (var e = "", t = this.pos; ; ) {
    this.pos >= this.input.length && this.raise(this.start, "Unterminated template");
    var i = this.input.charCodeAt(this.pos);
    if (i === 96 || i === 36 && this.input.charCodeAt(this.pos + 1) === 123)
      return this.pos === this.start && (this.type === r.template || this.type === r.invalidTemplate) ? i === 36 ? (this.pos += 2, this.finishToken(r.dollarBraceL)) : (++this.pos, this.finishToken(r.backQuote)) : (e += this.input.slice(t, this.pos), this.finishToken(r.template, e));
    if (i === 92)
      e += this.input.slice(t, this.pos), e += this.readEscapedChar(!0), t = this.pos;
    else if (K(i)) {
      switch (e += this.input.slice(t, this.pos), ++this.pos, i) {
        case 13:
          this.input.charCodeAt(this.pos) === 10 && ++this.pos;
        case 10:
          e += `
`;
          break;
        default:
          e += String.fromCharCode(i);
          break;
      }
      this.options.locations && (++this.curLine, this.lineStart = this.pos), t = this.pos;
    } else
      ++this.pos;
  }
};
m.readInvalidTemplateToken = function() {
  for (; this.pos < this.input.length; this.pos++)
    switch (this.input[this.pos]) {
      case "\\":
        ++this.pos;
        break;
      case "$":
        if (this.input[this.pos + 1] !== "{")
          break;
      // fall through
      case "`":
        return this.finishToken(r.invalidTemplate, this.input.slice(this.start, this.pos));
      case "\r":
        this.input[this.pos + 1] === `
` && ++this.pos;
      // fall through
      case `
`:
      case "\u2028":
      case "\u2029":
        ++this.curLine, this.lineStart = this.pos + 1;
        break;
    }
  this.raise(this.start, "Unterminated template");
};
m.readEscapedChar = function(e) {
  var t = this.input.charCodeAt(++this.pos);
  switch (++this.pos, t) {
    case 110:
      return `
`;
    // 'n' -> '\n'
    case 114:
      return "\r";
    // 'r' -> '\r'
    case 120:
      return String.fromCharCode(this.readHexChar(2));
    // 'x'
    case 117:
      return O(this.readCodePoint());
    // 'u'
    case 116:
      return "	";
    // 't' -> '\t'
    case 98:
      return "\b";
    // 'b' -> '\b'
    case 118:
      return "\v";
    // 'v' -> '\u000b'
    case 102:
      return "\f";
    // 'f' -> '\f'
    case 13:
      this.input.charCodeAt(this.pos) === 10 && ++this.pos;
    // '\r\n'
    case 10:
      return this.options.locations && (this.lineStart = this.pos, ++this.curLine), "";
    case 56:
    case 57:
      if (this.strict && this.invalidStringToken(
        this.pos - 1,
        "Invalid escape sequence"
      ), e) {
        var i = this.pos - 1;
        this.invalidStringToken(
          i,
          "Invalid escape sequence in template string"
        );
      }
    default:
      if (t >= 48 && t <= 55) {
        var s = this.input.substr(this.pos - 1, 3).match(/^[0-7]+/)[0], a = parseInt(s, 8);
        return a > 255 && (s = s.slice(0, -1), a = parseInt(s, 8)), this.pos += s.length - 1, t = this.input.charCodeAt(this.pos), (s !== "0" || t === 56 || t === 57) && (this.strict || e) && this.invalidStringToken(
          this.pos - 1 - s.length,
          e ? "Octal literal in template string" : "Octal literal in strict mode"
        ), String.fromCharCode(a);
      }
      return K(t) ? (this.options.locations && (this.lineStart = this.pos, ++this.curLine), "") : String.fromCharCode(t);
  }
};
m.readHexChar = function(e) {
  var t = this.pos, i = this.readInt(16, e);
  return i === null && this.invalidStringToken(t, "Bad character escape sequence"), i;
};
m.readWord1 = function() {
  this.containsEsc = !1;
  for (var e = "", t = !0, i = this.pos, s = this.options.ecmaVersion >= 6; this.pos < this.input.length; ) {
    var a = this.fullCharCodeAtPos();
    if (U(a, s))
      this.pos += a <= 65535 ? 1 : 2;
    else if (a === 92) {
      this.containsEsc = !0, e += this.input.slice(i, this.pos);
      var n = this.pos;
      this.input.charCodeAt(++this.pos) !== 117 && this.invalidStringToken(this.pos, "Expecting Unicode escape sequence \\uXXXX"), ++this.pos;
      var o = this.readCodePoint();
      (t ? L : U)(o, s) || this.invalidStringToken(n, "Invalid Unicode escape"), e += O(o), i = this.pos;
    } else
      break;
    t = !1;
  }
  return e + this.input.slice(i, this.pos);
};
m.readWord = function() {
  var e = this.readWord1(), t = r.name;
  return this.keywords.test(e) && (t = ye[e]), this.finishToken(t, e);
};
var ei = "8.18.0";
_.acorn = {
  Parser: _,
  version: ei,
  defaultOptions: ve,
  Position: Z,
  SourceLocation: ne,
  getLineInfo: Me,
  Node: ce,
  TokenType: g,
  tokTypes: r,
  keywordTypes: ye,
  TokContext: T,
  tokContexts: y,
  isIdentifierChar: U,
  isIdentifierStart: L,
  Token: Ee,
  isNewLine: K,
  lineBreak: w,
  lineBreakG: St,
  nonASCIIwhitespace: De
};
const Te = `export {};
`, pe = (e) => e.startsWith(Te) ? e.slice(Te.length) : e.startsWith("export {};") ? e.slice(10) : e, ai = (e) => e.replace(/(:\s*")export \{\};(?:\\n)?/g, "$1"), mt = {
  experimental: {
    ecmaVersion: "latest",
    sourceType: "module",
    allowReturnOutsideFunction: !0
  },
  legacy: {
    ecmaVersion: "latest",
    sourceType: "script",
    allowReturnOutsideFunction: !0
  }
}, ni = (e, t = "experimental") => {
  _.parse(e, mt[t]);
}, ti = /* @__PURE__ */ new Set(["__hoppReporter", "globalThis"]), ii = (e) => e.type === "ImportDeclaration" || e.type === "ExportAllDeclaration" || e.type === "ExportNamedDeclaration" && e.source !== null, si = (e) => {
  const t = {
    importStatements: [],
    body: e,
    bindings: []
  };
  if (!e.trim()) return t;
  let i;
  try {
    i = _.parse(e, mt.experimental);
  } catch (u) {
    return {
      ...t,
      parseError: u instanceof Error ? u.message : String(u)
    };
  }
  const s = i.body.filter(ii);
  if (s.length === 0) return t;
  let a = "", n = 0;
  for (const u of s)
    a += e.slice(n, u.start), n = u.end;
  a += e.slice(n);
  const o = s.filter((u) => u.type === "ImportDeclaration").flatMap(
    (u) => u.specifiers.map((h) => ({
      name: h.local.name,
      source: String(u.source.value ?? "")
    }))
  );
  return {
    importStatements: s.map((u) => e.slice(u.start, u.end)),
    body: a,
    bindings: o
  };
}, ri = (e) => {
  const t = pe(e.trim());
  return t ? `function() {
${t}
}` : "";
}, oi = (e, t = "experimental") => {
  if (t === "legacy") {
    const x = e.map(ri).filter((E) => E);
    return x.length === 0 ? "" : x.map((E) => `;(${E}).call(this);`).join(`
`);
  }
  const i = e.map(
    (x) => si(pe(x.trim()))
  ), s = i.map(
    ({ body: x }) => x.trim() ? `async function() {
${x.trim()}
}` : ""
  ).filter((x) => x), a = [
    ...new Set(i.flatMap((x) => x.importStatements))
  ].filter(Boolean), n = i.find((x) => x.parseError)?.parseError, o = /* @__PURE__ */ new Map();
  for (const { name: x, source: E } of i.flatMap((F) => F.bindings))
    o.has(x) || o.set(x, /* @__PURE__ */ new Set()), o.get(x).add(E);
  const u = [...o.entries()].find(
    ([, x]) => x.size > 1
  )?.[0], h = new Set(
    i.flatMap((x) => x.bindings.map((E) => E.name))
  ), p = [...ti].find(
    (x) => h.has(x)
  );
  if (s.length === 0 && a.length === 0 && !n) return "";
  if (n !== void 0)
    return te(
      `throw new SyntaxError(${JSON.stringify(`[Hoppscotch] Script failed to parse: ${n}`)});`
    );
  if (u !== void 0)
    return te(
      `throw new SyntaxError(${JSON.stringify(`[Hoppscotch] '${u}' is imported from different sources across scripts in this request's chain. Please import it from a single source, or rename one of the imports to resolve the conflict.`)});`
    );
  if (p !== void 0)
    return te(
      `throw new SyntaxError(${JSON.stringify(`[Hoppscotch] '${p}' is reserved by Hoppscotch's script wrapper and cannot be used as an import binding. Please rename the import.`)});`
    );
  if (s.length === 0) return a.join(`
`);
  const d = s.map((x) => `await (${x})();`).join(`
`), b = te(d);
  return a.length === 0 ? b : [a.join(`
`), b].join(`
`);
}, te = (e) => [
  "const __hoppReporter = globalThis.__hoppReportScriptExecutionError;",
  "try {",
  e,
  "} catch (__hoppScriptExecutionError) {",
  "  __hoppReporter(__hoppScriptExecutionError);",
  "}"
].join(`
`), ui = (e) => e ? pe(e.trim()).length > 0 : !1, hi = (e) => e.filter(
  (t) => typeof t == "string" && pe(t).trim().length > 0
);
export {
  Te as M,
  pe as a,
  oi as c,
  hi as f,
  ui as h,
  ni as p,
  ai as s
};
